/**
 * ATC Bundle SOR - SORAALI Interactive Components
 * Handles frequency selection, expandable sections, add to cart, and pack routine
 */

class ATCBundleSOR {
  constructor(container) {
    this.container = container;
    if (!this.container) return;

    this.checkSubscriptionParam();
    this.initializeElements();
    this.bindEvents();
    this.initializeFrequencySelection();
    this.updatePricing();
    this.updateStockDisplay();
    this.initializeExpandableSections();
    this.initializeMediaGallery();
    this.initializeModals();
    this.connectInfoButtonsToModals();
    this.initializeInfoButtons();
    this.initStickyBar();
    this.initializeBenefitsShowMore();
    this.checkIngredientsSection();
  }

  checkSubscriptionParam() {
    const urlParams = new URLSearchParams(window.location.search);
    const subscriptionParam = urlParams.get("subscription");

    if (subscriptionParam === "false") {
      this.subscriptionDisabled = true;

      this.container.classList.add("atc-bundle-sor--subscription-disabled");

      const oneTimeInput = this.container.querySelector(
        'input[value="onetime"]'
      );
      if (oneTimeInput) {
        oneTimeInput.checked = true;
      }
    } else {
      this.subscriptionDisabled = false;
    }
  }

  initializeElements() {
    this.frequencyInputs = this.container.querySelectorAll(
      ".atc-bundle-sor__frequency-input"
    );
    this.periodButtons = this.container.querySelectorAll(
      ".atc-bundle-sor__period-option"
    );

    this.ctaButton = this.container.querySelector(
      ".atc-bundle-sor__cta-button"
    );
    this.ctaPrice = this.container.querySelector(".atc-bundle-sor__cta-price");

    this.stickyButtons = document.querySelectorAll(
      ".atc-bundle-sor__sticky-cta"
    );
    this.stickyPrices = document.querySelectorAll(
      ".atc-bundle-sor__sticky-cta-price"
    );
    this.stickyOriginalPrices = document.querySelectorAll(
      ".atc-bundle-sor__sticky-cta-original"
    );

    this.packCta = this.container.querySelector(".atc-bundle-sor__pack-cta");
    this.packSingleCta = this.container.querySelector(
      ".atc-bundle-sor__pack-single-cta"
    );

    this.expandableSections = this.container.querySelectorAll(
      ".atc-bundle-sor__expandable-section"
    );

    this.variantOptions = this.container.querySelectorAll(
      ".atc-bundle-sor__variant-option"
    );
    this.variantPicker = this.container.querySelector(
      ".atc-bundle-sor__variant-picker"
    );

    this.infoButtons = this.container.querySelectorAll(
      ".atc-bundle-sor__info-btn"
    );

    this.mainImage = this.container.querySelector(
      ".atc-bundle-sor__main-image"
    );
    this.thumbnails = this.container.querySelectorAll(
      ".atc-bundle-sor__thumbnail"
    );
    this.mobileSwiper = this.container.querySelector(
      ".atc-bundle-sor__mobile-swiper"
    );
    this.mobileNavPrev = this.container.querySelector(
      ".atc-bundle-sor__mobile-nav-prev"
    );
    this.mobileNavNext = this.container.querySelector(
      ".atc-bundle-sor__mobile-nav-next"
    );
    this.mobilePagination = this.container.querySelector(
      ".atc-bundle-sor__mobile-pagination"
    );

    this.sellingPlansData = this.getSellingPlansData();
    this.frequencySettings = this.getFrequencySettings();

    this.stickyBar = null;
    this.stickyDesktopVariants = null;
    this.stickyMobileVariants = null;
    this.stickyDesktopFrequencies = null;
    this.stickyMobileFrequencies = null;

    this.currentFrequency = null;
    this.currentSellingPlanId = null;
    this.currentVariantId = null;
    this.currentVariantPrice = null;

    this.initializeVariantSelection();

    if (document.querySelector('.w-blackfriday-hero__header')) {
      if (window.innerWidth < 600)  
        this.container.querySelector('.atc-bundle-sor__cta-text').textContent = 'Ajouter';
    }
  }

  bindEvents() {
    this.frequencyInputs.forEach((input) => {
      input.addEventListener("change", (e) => {
        if (this.subscriptionDisabled && input.value === "subscription") {
          e.preventDefault();
          const oneTimeInput = this.container.querySelector(
            'input[value="onetime"]'
          );
          if (oneTimeInput) {
            oneTimeInput.checked = true;
          }
          return;
        }
        this.handleFrequencyChange(e);
      });
    });

    this.periodButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => this.handlePeriodChange(e, null));
    });

    const quantitySelect = this.container.querySelector(
      ".atc-bundle-sor__quantity-select"
    );
    if (quantitySelect) {
      quantitySelect.addEventListener("change", () => {
        this.updatePricing();
      });
    }

    if (this.ctaButton) {
      this.ctaButton.addEventListener("click", (e) => this.handleAddToCart(e));
    }

    this.stickyButtons.forEach((button) => {
      button.addEventListener("click", (e) => this.handleStickyAddToCart(e));
    });

    if (this.packCta) {
      this.packCta.addEventListener("click", (e) =>
        this.handlePackRoutineAdd(e)
      );
    }

    if (this.packSingleCta) {
      this.packSingleCta.addEventListener("click", (e) =>
        this.handlePackSingleAdd(e)
      );
    }

    this.expandableSections.forEach((section) => {
      const header = section.querySelector(".atc-bundle-sor__section-header");
      if (header) {
        header.addEventListener("click", (e) =>
          this.toggleExpandableSection(e, section)
        );
      }

      const seeMoreBtn = section.querySelector(".atc-bundle-sor__see-more-btn");
      if (seeMoreBtn) {
        seeMoreBtn.addEventListener("click", (e) =>
          this.handleSeeMoreClick(e, section)
        );
      }
    });

    this.variantOptions.forEach((option) => {
      option.addEventListener("click", (e) => this.handleVariantSelection(e));
    });

    this.infoButtons.forEach((btn) => {
      if (!btn.hasAttribute("data-modal-trigger")) {
        btn.addEventListener("click", (e) => this.handleInfoButtonClick(e));
      }
    });

    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", (e) => this.handleThumbnailClick(e));
    });

    if (this.mobileNavPrev) {
      this.mobileNavPrev.addEventListener("click", () =>
        this.handleMobilePrevClick()
      );
    }
    if (this.mobileNavNext) {
      this.mobileNavNext.addEventListener("click", () =>
        this.handleMobileNextClick()
      );
    }
  }

  initializeFrequencySelection() {
    if (this.subscriptionDisabled) {
      const oneTimeInput = this.container.querySelector(
        'input[value="onetime"]'
      );
      if (oneTimeInput && !oneTimeInput.checked) {
        oneTimeInput.checked = true;
        oneTimeInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  initializeExpandableSections() {
    const benefitsSection = this.container.querySelector(
      ".atc-bundle-sor__expandable-section--expanded"
    );
    if (benefitsSection) {
      this.updateSectionToggleIcon(benefitsSection, true);
    }

    const expandableBlocks = this.container.querySelectorAll(
      ".atc-bundle-sor__expandable-block"
    );

    expandableBlocks.forEach((block) => {
      const header = block.querySelector(".atc-bundle-sor__block-header");

      if (header) {
        header.addEventListener("click", () => {
          block.classList.toggle("atc-bundle-sor__expandable-block--expanded");
        });
      }

      const seeMoreBtn = block.querySelector(".atc-bundle-sor__see-more-btn");
      if (seeMoreBtn) {
        seeMoreBtn.addEventListener("click", (e) =>
          this.handleSeeMoreClick(e, block)
        );
      }
    });
  }

  initializeVariantSelection() {
    const selectedVariantOption = this.container.querySelector(
      ".atc-bundle-sor__variant-option--selected"
    );
    if (selectedVariantOption) {
      this.currentVariantId = selectedVariantOption.dataset.variantId;
      this.currentVariantPrice = parseFloat(
        selectedVariantOption.dataset.variantPrice
      );
    } else {
      const ctaButton = this.container.querySelector(
        ".atc-bundle-sor__cta-button"
      );
      if (ctaButton) {
        this.currentVariantId = ctaButton.dataset.variantId;

        const onetimePrice = this.container.querySelector(
          ".atc-bundle-sor__onetime-price"
        );
        if (onetimePrice) {
          const priceText = onetimePrice.textContent;
          this.currentVariantPrice = this.extractPriceFromText(priceText) * 100;
        } else if (this.ctaPrice) {
          const priceText = this.ctaPrice.textContent;
          this.currentVariantPrice = this.extractPriceFromText(priceText) * 100;
        }
      }
    }

    const checkedFrequencyInput = this.container.querySelector(
      ".atc-bundle-sor__frequency-input:checked"
    );
    if (checkedFrequencyInput) {
      this.currentFrequency = checkedFrequencyInput.value;
      if (this.currentFrequency.startsWith("selling_plan_")) {
        this.currentSellingPlanId = this.currentFrequency.replace(
          "selling_plan_",
          ""
        );
      } else {
        this.currentSellingPlanId = null;
      }
    }

    this.updatePricing();
    this.updateSubscriptionDisplay();
    this.updateVariantSavingsBadges();

    if (this.currentVariantId) {
      this.updateSubscriptionInfo(this.currentVariantId);
    }
  }

  initializeMediaGallery() {
    this.initializeDesktopGallery();
    this.initializeMobileGallery();
  }

  initializeDesktopGallery() {
    const desktopGallery = this.container.querySelector(
      ".atc-bundle-sor__desktop-gallery"
    );
    if (!desktopGallery) return;

    const mainSwiper = desktopGallery.querySelector(
      ".atc-bundle-sor__main-swiper"
    );
    if (mainSwiper && typeof Swiper !== "undefined") {
      this.mainSwiper = new Swiper(mainSwiper, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        effect: "slide",
        speed: 300,
        allowTouchMove: false,
      });
    }

    this.initializeThumbnails();
  }

  initializeThumbnails() {
    const thumbnails = this.container.querySelectorAll(
      ".atc-bundle-sor__thumbnail"
    );

    if (!thumbnails.length) return;

    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener("click", () => {
        thumbnails.forEach((t) =>
          t.classList.remove("atc-bundle-sor__thumbnail--active")
        );

        thumb.classList.add("atc-bundle-sor__thumbnail--active");

        if (this.mainSwiper) {
          this.mainSwiper.slideTo(index);
        }
      });
    });

    if (thumbnails.length > 0) {
      thumbnails[0].classList.add("atc-bundle-sor__thumbnail--active");
    }
  }

  initializeMobileGallery() {
    const mobileGallery = this.container.querySelector(
      ".atc-bundle-sor__mobile-gallery"
    );
    if (!mobileGallery) return;

    const mobileSwiper = mobileGallery.querySelector(
      ".atc-bundle-sor__mobile-swiper"
    );
    if (mobileSwiper && typeof Swiper !== "undefined") {
      this.mobileSwiper = new Swiper(mobileSwiper, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        effect: "slide",
        speed: 300,
        allowTouchMove: true,
        pagination: {
          el: mobileSwiper.querySelector(".atc-bundle-sor__mobile-pagination"),
          clickable: true,
          type: "bullets",
        },
        navigation: {
          nextEl: mobileSwiper.querySelector(
            ".atc-bundle-sor__mobile-nav-next"
          ),
          prevEl: mobileSwiper.querySelector(
            ".atc-bundle-sor__mobile-nav-prev"
          ),
        },
      });
    }
  }

  getSellingPlansData() {
    const scriptElement = document.getElementById("selling-plans-data");
    if (scriptElement) {
      try {
        return JSON.parse(scriptElement.textContent);
      } catch (error) {
        return {};
      }
    }
    return {};
  }

  getFrequencySettings() {
    const scriptElement = document.getElementById("frequency-settings");
    if (scriptElement) {
      try {
        return JSON.parse(scriptElement.textContent);
      } catch (error) {
        return {};
      }
    }
    return {};
  }

  handleFrequencyChange(e) {
    const frequency = e.target.value;
    this.currentFrequency = frequency;

    if (frequency.startsWith("selling_plan_")) {
      this.currentSellingPlanId = frequency.replace("selling_plan_", "");
    } else {
      this.currentSellingPlanId = null;
    }

    this.updateFrequencyCards();
    this.updatePricing();
    this.updateSubscriptionDisplay();

    this.syncStickyFrequencyWithMain(frequency);

    this.trackFrequencySelection(frequency);
  }

  handlePeriodChange(e = null, buttonCustomTarget = null) {
    e?.preventDefault();
    const button = e?.currentTarget || buttonCustomTarget;
    const sellingPlanId = button.dataset.sellingPlanId;

    this.periodButtons.forEach((btn) =>
      btn.classList.remove("atc-bundle-sor__period-option--active")
    );
    button.classList.add("atc-bundle-sor__period-option--active");

    if(e || this.currentFrequency !== "onetime") this.currentSellingPlanId = sellingPlanId;

    const subscriptionInput = this.container.querySelector(
      "#frequency-subscription"
    );
    if (subscriptionInput) {
      subscriptionInput.value = `selling_plan_${sellingPlanId}`;
      subscriptionInput.dataset.sellingPlanId = sellingPlanId;
    }

    if(e && this.currentFrequency === "onetime"){
      document.querySelector('.atc-bundle-sor__subscription-label').click();
    }

    this.updatePricing();
    this.updateSubscriptionDisplay();

    this.updateAllVariantsPricing();

    this.syncStickyPeriodWithMain(sellingPlanId);

    this.trackPeriodChange(sellingPlanId);
  }

  updateFrequencyCards() {
    const onetimeContainer = this.container.querySelector(
      ".atc-bundle-sor__onetime-container"
    );
    const subscriptionContainer = this.container.querySelector(
      ".atc-bundle-sor__subscription-container"
    );

    if (this.currentFrequency === "onetime") {
      onetimeContainer?.classList.add(
        "atc-bundle-sor__frequency-container--selected"
      );
      subscriptionContainer?.classList.remove(
        "atc-bundle-sor__frequency-container--selected"
      );
    } else {
      onetimeContainer?.classList.remove(
        "atc-bundle-sor__frequency-container--selected"
      );
      subscriptionContainer?.classList.add(
        "atc-bundle-sor__frequency-container--selected"
      );
    }
  }

  updateSubscriptionDisplay() {
    if (!this.currentSellingPlanId || !this.currentVariantId) return;

    const planData = this.findSellingPlanForVariant(
      this.currentVariantId,
      this.currentSellingPlanId
    );
    if (!planData) return;

    const discountBadge = this.container.querySelector(
      "[data-discount-display]"
    );
    if (discountBadge) {
      if (planData.discount_type === "percentage") {
        discountBadge.textContent = `-${planData.discount_value}%`;
      } else if (planData.discount_type === "fixed_amount") {
        discountBadge.textContent = `-${(planData.discount_value / 100).toFixed(
          2
        )}€`;
      }
    }
  }

  extractPriceFromText(priceText) {
    const match = priceText.match(/[\d,\.]+/);
    if (match) {
      return parseFloat(match[0].replace(",", "."));
    }
    return 0;
  }

  findSellingPlanForVariant(variantId, sellingPlanId) {
    return Object.values(this.sellingPlansData).find((planData) => {
      return (
        planData.variant_id &&
        planData.variant_id.toString() === variantId.toString() &&
        (planData.selling_plan_id === sellingPlanId ||
          planData.id === sellingPlanId)
      );
    });
  }

  calculateTotalGiftValue() {
    let totalGiftValue = 0;

    const giftItems = this.container.querySelectorAll(".atc-bundle-sor__gift");
    giftItems.forEach((giftItem) => {
      const giftOldPrice = giftItem.querySelector(
        ".atc-bundle-sor__gift-old-price"
      );
      if (giftOldPrice) {
        const priceText = giftOldPrice.textContent;
        const priceValue = this.extractPriceFromText(priceText);
        totalGiftValue += priceValue * 100;
      }
    });


    return totalGiftValue;
  }

  updateVariantSavingsBadges() {}

  getQuantity() {
    const quantitySelect = this.container.querySelector(
      ".atc-bundle-sor__quantity-select"
    );
    return quantitySelect ? parseInt(quantitySelect.value, 10) : 1;
  }

  updatePricing() {
    if (!this.ctaPrice) {
      return;
    }

    const useDiscountAuto = this.container.querySelector(".atc-bundle-sor__quantity-select")?.dataset.useDiscountAuto ? true : undefined;
    const useDiscountThirdFree = this.container.querySelector(".atc-bundle-sor__quantity-select")?.dataset.useDiscountThirdFree ? true : undefined;
    let price;
    let priceByDiscountAuto;
    const quantity = this.getQuantity();

    if (this.currentFrequency === "onetime" || this.currentFrequency === null) {
      if (this.currentVariantPrice) {
        price = (this.currentVariantPrice / 100) * quantity;

        if(useDiscountAuto){
          if(quantity == 2){
            priceByDiscountAuto = (this.currentVariantPrice / 100) * 1.5;
          }
          else if(quantity == 3){
            priceByDiscountAuto = useDiscountThirdFree ? (this.currentVariantPrice / 100) * 2 : (this.currentVariantPrice / 100) * 2.5;
          }
          else if(quantity == 4){
            priceByDiscountAuto = (this.currentVariantPrice / 100) * 3;
          }
        }
      }
    } else if (this.currentSellingPlanId && this.currentVariantId) {
      const planData = this.findSellingPlanForVariant(
        this.currentVariantId,
        this.currentSellingPlanId
      );
      if (planData) {
        price = (planData.allocation_price / 100) * quantity;
      } else if (this.currentVariantPrice) {
        price = (this.currentVariantPrice / 100) * quantity;
      }
    }

    if (price) {
      const formattedPrice = `${price.toFixed(2).replace(".", ",")}€`;

      const formattedPriceDiscountAuto = `${priceByDiscountAuto?.toFixed(2).replace(".", ",")}€`;

      if(useDiscountAuto){
        this.ctaPrice.textContent = priceByDiscountAuto ? formattedPriceDiscountAuto : formattedPrice;
        this.stickyPrices.forEach((stickyPrice) => {
          stickyPrice.textContent = priceByDiscountAuto ? formattedPriceDiscountAuto : formattedPrice;
        });
      } else {
        this.ctaPrice.textContent = formattedPrice;
        this.stickyPrices.forEach((stickyPrice) => {
          stickyPrice.textContent = formattedPrice;
        });
      }

      if (this.currentVariantId) {
        if (this.ctaButton) {
          this.ctaButton.setAttribute("data-variant-id", this.currentVariantId);
        }
        this.stickyButtons.forEach((stickyButton) => {
          stickyButton.setAttribute("data-variant-id", this.currentVariantId);
        });
      }
    }

    const ctaOriginal = this.container.querySelector(
      ".atc-bundle-sor__cta-original"
    );

    if (ctaOriginal && this.currentVariantPrice && this.currentVariantId) {
      const totalGiftValue = this.calculateTotalGiftValue();
      console.log("TOTAL GIFT VALUE -> " + totalGiftValue);
      if (totalGiftValue > 0) {
        const originalPriceWithGifts =
          ((this.currentVariantPrice + totalGiftValue) / 100) * quantity;
        const formattedOriginalPrice = `${originalPriceWithGifts
          .toFixed(2)
          .replace(".", ",")}€`;
        ctaOriginal.textContent = formattedOriginalPrice;
        ctaOriginal.style.display = "inline";

        this.stickyOriginalPrices.forEach((stickyOriginalPrice) => {
          stickyOriginalPrice.textContent = formattedOriginalPrice;
          stickyOriginalPrice.style.display = "inline";
        });
      } else if (
        window.variantData &&
        window.variantData[this.currentVariantId]
      ) {
        const variant = window.variantData[this.currentVariantId];

        if (this.currentSellingPlanId) {
          const planData = this.findSellingPlanForVariant(
            this.currentVariantId,
            this.currentSellingPlanId
          );

          if (planData) {
            const discountedPrice =
              (planData.allocation_price / 100) * quantity;
            const compareAtPrice = variant.compare_at_price
              ? (variant.compare_at_price / 100) * quantity
              : null;
            const variantPrice = (variant.price / 100) * quantity;

            const originalPrice = compareAtPrice || variantPrice;

            if (originalPrice !== discountedPrice) {
              const formattedOriginalPrice = `${originalPrice
                .toFixed(2)
                .replace(".", ",")}€`;
              ctaOriginal.textContent = formattedOriginalPrice;
              ctaOriginal.style.display = "inline";

              this.stickyOriginalPrices.forEach((stickyOriginalPrice) => {
                stickyOriginalPrice.textContent = formattedOriginalPrice;
                stickyOriginalPrice.style.display = "inline";
              });
            } else {
              ctaOriginal.style.display = "none";
              this.stickyOriginalPrices.forEach((stickyOriginalPrice) => {
                stickyOriginalPrice.style.display = "none";
              });
            }
          }
        } else if (
          variant.compare_at_price &&
          variant.compare_at_price > variant.price
        ) {
          const compareAtPrice = (variant.compare_at_price / 100) * quantity;
          const formattedComparePrice = `${compareAtPrice
            .toFixed(2)
            .replace(".", ",")}€`;
          ctaOriginal.textContent = formattedComparePrice;
          ctaOriginal.style.display = "inline";

          this.stickyOriginalPrices.forEach((stickyOriginalPrice) => {
            stickyOriginalPrice.textContent = formattedComparePrice;
            stickyOriginalPrice.style.display = "inline";
          });
        } else {
          ctaOriginal.style.display = "none";
          this.stickyOriginalPrices.forEach((stickyOriginalPrice) => {
            stickyOriginalPrice.style.display = "none";
          });
        }
      }
    }

    if(useDiscountAuto && priceByDiscountAuto){

      const formattedPrice = `${price.toFixed(2).replace(".", ",")}€`;
      
      ctaOriginal.style.display = "inline";
      ctaOriginal.textContent = formattedPrice;

      this.stickyOriginalPrices.forEach((stickyOriginalPrice) => {
        stickyOriginalPrice.style.display = "inline";
        stickyOriginalPrice.textContent = formattedPrice;
      });
    }

    this.updateBlackFridayPrice();
    this.updateFrequencyPrices();
    
  }

  updateBlackFridayPrice() {
    const bfPriceBlock = this.container.querySelector("[data-bf-price]");
    if (!bfPriceBlock) {
      return;
    }

    const quantity = this.getQuantity();
    const comparePriceEl = bfPriceBlock.querySelector(
      "[data-bf-compare-price]"
    );
    const currentPriceEl = bfPriceBlock.querySelector(
      "[data-bf-current-price]"
    );
    const badgeEl = bfPriceBlock.querySelector("[data-bf-badge]");
    const discountEl = bfPriceBlock.querySelector("[data-bf-discount]");

    const useDiscountAuto = this.container.querySelector(".atc-bundle-sor__quantity-select").dataset.useDiscountAuto ? true : undefined;
    const useDiscountThirdFree = this.container.querySelector(".atc-bundle-sor__quantity-select").dataset.useDiscountThirdFree ? true : undefined;

    const variant = window.variantData[this.currentVariantId];
    let currentPrice = variant.price;
    let compareAtPrice = variant.compare_at_price;

    if(useDiscountAuto){

      let comparePriceDiscountAuto  = variant.price;
      let priceDiscountAuto;

      if(quantity == 2){
        priceDiscountAuto = (variant.price / 100) * 1.5;
      }
      else if(quantity == 3){
        priceDiscountAuto = useDiscountThirdFree ? (variant.price / 100) * 2 : (variant.price / 100) * 2.5;
      }
      else if(quantity == 4){
        priceDiscountAuto = (variant.price / 100) * 3;
      }

      const formattedComparePriceDiscountAuto = `${((comparePriceDiscountAuto / 100) * quantity)
        .toFixed(2)
        .replace(".", ",")}€`;

      const formattedPriceDiscountAuto = `${(priceDiscountAuto)?.toFixed(2).replace(".", ",")}€`;

      if(quantity == 1){
        if (currentPriceEl) currentPriceEl.textContent = `${((comparePriceDiscountAuto / 100) * quantity)
        .toFixed(2)
        .replace(".", ",")}€`;;
        comparePriceEl.style.display = "none";
      }
      else{
        if (currentPriceEl) currentPriceEl.textContent = formattedPriceDiscountAuto;

        if (comparePriceEl) {
          comparePriceEl.textContent = formattedComparePriceDiscountAuto;
          comparePriceEl.style.display = "flex";
        }
      }
      
      return;
    }
  
    if (
      !this.currentVariantId ||
      !window.variantData ||
      !window.variantData[this.currentVariantId]
    ) {
      if (comparePriceEl) comparePriceEl.style.display = "none";
      if (badgeEl) badgeEl.style.display = "none";
      return;
    }

    if (this.currentFrequency === "subscription" && this.currentSellingPlanId) {
      const planData = this.findSellingPlanForVariant(
        this.currentVariantId,
        this.currentSellingPlanId
      );
      if (planData) {
        currentPrice = planData.allocation_price;
        compareAtPrice = variant.price;
      }
    }

    const formattedCurrentPrice = `${((currentPrice / 100) * quantity)
      .toFixed(2)
      .replace(".", ",")}€`;
    if (currentPriceEl) currentPriceEl.textContent = formattedCurrentPrice;

    if (!compareAtPrice || compareAtPrice <= currentPrice) {
      if (comparePriceEl) comparePriceEl.style.display = "none";
      if (badgeEl) badgeEl.style.display = "none";
      return;
    }

    const formattedComparePrice = `${((compareAtPrice / 100) * quantity)
      .toFixed(2)
      .replace(".", ",")}€`;
    const discount = Math.round(
      ((compareAtPrice - currentPrice) * 100) / compareAtPrice
    );

    if (comparePriceEl) {
      comparePriceEl.textContent = formattedComparePrice;
      comparePriceEl.style.display = "flex";
    }

    if (discountEl) discountEl.textContent = `-${discount}%`;
    if (badgeEl) badgeEl.style.display = "flex";

    this.container.querySelector('.atc-bundle-sor__cta-original').textContent = formattedComparePrice;
  }

  updateFrequencyPrices() {
    const quantity = this.getQuantity();

    let sellingPlanId = null;
    if(this.currentSellingPlanId){
      sellingPlanId = this.currentSellingPlanId;
    } else {
      sellingPlanId = document.querySelector('.atc-bundle-sor__period-option--active')?.dataset.sellingPlanId;
    }

    sellingPlanId = sellingPlanId;

    const onetimePrice = this.container.querySelector(
      ".atc-bundle-sor__onetime-price"
    );
    if (onetimePrice && this.currentVariantPrice) {
      const price = (this.currentVariantPrice / 100) * quantity;
      const formattedPrice = `${price.toFixed(2).replace(".", ",")}€`;
      onetimePrice.textContent = formattedPrice;
    }

    const subscriptionPrices = this.container.querySelectorAll(
      ".atc-bundle-sor__subscription-price"
    );
    subscriptionPrices.forEach((subscriptionPrice) => {
      if (this.currentVariantId) {
        const planData = this.findSellingPlanForVariant(
          this.currentVariantId,
          sellingPlanId
        );
        
        if (planData) {
          const price = (planData.allocation_price / 100) * quantity;
          const formattedPrice = `${price.toFixed(2).replace(".", ",")}€`;
          subscriptionPrice.textContent = formattedPrice;
        }
      }
    });

    const onetimeOriginals = this.container.querySelectorAll(
      ".atc-bundle-sor__onetime-original"
    );
    const onetimePriceElements = this.container.querySelectorAll(
      ".atc-bundle-sor__onetime-price"
    );

    onetimeOriginals.forEach((onetimeOriginal, index) => {
      if (this.currentVariantId) {
        const variantData = window.variantData
          ? window.variantData[this.currentVariantId]
          : null;

        if (variantData) {
          const compareAtPrice = variantData.compare_at_price
            ? (variantData.compare_at_price / 100) * quantity
            : null;
          const currentPrice = (variantData.price / 100) * quantity;

          if (compareAtPrice && compareAtPrice > currentPrice) {
            onetimeOriginal.style.display = "inline";
            const formattedPrice = `${compareAtPrice
              .toFixed(2)
              .replace(".", ",")}€`;
            onetimeOriginal.textContent = formattedPrice;
          } else {
            onetimeOriginal.style.display = "none";
          }
        }
      }
    });

    const subscriptionOriginals = this.container.querySelectorAll(
      ".atc-bundle-sor__subscription-original"
    );
    subscriptionOriginals.forEach((subscriptionOriginal) => {
      if (this.currentVariantId) {
        const planData = this.findSellingPlanForVariant(
          this.currentVariantId,
          this.currentSellingPlanId
        );
        const variantData = window.variantData
          ? window.variantData[this.currentVariantId]
          : null;

        if (planData && variantData) {
          const discountedPrice = (planData.allocation_price / 100) * quantity;
          const compareAtPrice = variantData.compare_at_price
            ? (variantData.compare_at_price / 100) * quantity
            : null;
          const variantPrice = (variantData.price / 100) * quantity;

          const originalPrice = variantPrice;
          // const originalPrice = compareAtPrice || variantPrice;

          if (originalPrice === discountedPrice) {
            subscriptionOriginal.style.display = "none";
          } else {
            subscriptionOriginal.style.display = "inline";
            const formattedPrice = `${originalPrice
              .toFixed(2)
              .replace(".", ",")}€`;
            subscriptionOriginal.textContent = formattedPrice;
            document.querySelector('.atc-bundle-sor__cta-original').innerText = formattedPrice;
          }
        } else {
          const variantPrice = (variantData.price / 100) * quantity;
          const originalPrice = variantPrice;

          subscriptionOriginal.textContent = `${originalPrice
              .toFixed(2)
              .replace(".", ",")}€`;
        }
      }
    });
  }

  async handleAddToCart(e) {
    e.preventDefault();

    const button = e.currentTarget;
    const variantId = button.dataset.variantId;

    if (!variantId) {
      return;
    }

    const quantity = this.getQuantity();

    const originalHTML = button.innerHTML;
    button.innerHTML = "Ajout en cours...";
    button.disabled = true;

    try {
      let sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const formData = new FormData();
      formData.append("id", variantId);
      formData.append("quantity", quantity);
      if (this.currentSellingPlanId) {
        formData.append("selling_plan", this.currentSellingPlanId);
      }
      formData.append("sections", sectionsToBundle.join(","));
      formData.append(
        "sections_url",
        `${window.Shopify.routes.root}variants/${variantId}`
      );

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();

        // if (document.querySelector('.w-blackfriday-hero__header')) {
        //   window.location.href = '/checkout';
        //   return;
        // }

        const cartResponse = await fetch(
          `${window.Shopify.routes.root}cart.js`
        );
        const cartData = await cartResponse.json();
        cartData["sections"] = result["sections"];

        document.documentElement.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              cart: cartData,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartData,
            },
          })
        );

        console.log('on a dispatché les événements');

        this.showAddToCartSuccess();
        this.trackAddToCart(variantId, this.currentFrequency);

        this.updateCartCount();
      } else {
        throw new Error("Failed to add to cart");
      }
    } catch (error) {
      this.showAddToCartError();
    } finally {
      button.innerHTML = originalHTML;
      button.disabled = false;

      this.ctaPrice = this.container.querySelector(
        ".atc-bundle-sor__cta-price"
      );
    }
  }

  async handlePackRoutineAdd(e) {
    e.preventDefault();

    const button = e.currentTarget;
    const packProductId = button.dataset.packProductId;

    if (!packProductId) {
      return;
    }

    const originalHTML = button.innerHTML;
    button.innerHTML = "Ajout en cours...";
    button.disabled = true;

    try {
      let sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const formData = new FormData();
      formData.append("id", packProductId);
      formData.append("quantity", 1);
      formData.append("sections", sectionsToBundle.join(","));
      formData.append(
        "sections_url",
        `${window.Shopify.routes.root}variants/${packProductId}`
      );

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();

        const cartResponse = await fetch(
          `${window.Shopify.routes.root}cart.js`
        );
        const cartData = await cartResponse.json();
        cartData["sections"] = result["sections"];

        document.documentElement.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              cart: cartData,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartData,
            },
          })
        );

        this.showPackAddSuccess();
        this.trackPackRoutineAdd();
        this.updateCartCount();
      } else {
        throw new Error("Failed to add pack to cart");
      }
    } catch (error) {
      this.showPackAddError();
    } finally {
      button.innerHTML = originalHTML;
      button.disabled = false;

      this.ctaPrice = this.container.querySelector(
        ".atc-bundle-sor__cta-price"
      );
    }
  }

  async handlePackSingleAdd(e) {
    e.preventDefault();

    const button = e.currentTarget;
    const packSingleProductId = button.dataset.packSingleProductId;

    if (!packSingleProductId) {
      return;
    }

    const originalHTML = button.innerHTML;
    button.innerHTML =
      '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="4" fill="#004731" opacity="0.5"/></svg>';
    button.disabled = true;

    try {
      let sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const formData = new FormData();
      formData.append("id", packSingleProductId);
      formData.append("quantity", 1);
      formData.append("sections", sectionsToBundle.join(","));
      formData.append(
        "sections_url",
        `${window.Shopify.routes.root}variants/${packSingleProductId}`
      );

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();

        const cartResponse = await fetch(
          `${window.Shopify.routes.root}cart.js`
        );
        const cartData = await cartResponse.json();
        cartData["sections"] = result["sections"];

        document.documentElement.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              cart: cartData,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartData,
            },
          })
        );

        this.showPackAddSuccess();
        this.updateCartCount();
      } else {
        throw new Error("Failed to add single product to cart");
      }
    } catch (error) {
      this.showPackAddError();
    } finally {
      button.innerHTML = originalHTML;
      button.disabled = false;
    }
  }

  toggleExpandableSection(e, section) {
    e.preventDefault();

    const isExpanded = section.classList.contains(
      "atc-bundle-sor__expandable-section--expanded"
    );

    if (isExpanded) {
      section.classList.remove("atc-bundle-sor__expandable-section--expanded");
      this.slideUp(section.querySelector(".atc-bundle-sor__section-content"));
    } else {
      section.classList.add("atc-bundle-sor__expandable-section--expanded");
      this.slideDown(section.querySelector(".atc-bundle-sor__section-content"));
    }

    this.updateSectionToggleIcon(section, !isExpanded);

    this.trackSectionToggle(section, !isExpanded);
  }

  updateSectionToggleIcon(section, isExpanded) {
    const toggleIcon = section.querySelector(".atc-bundle-sor__toggle-icon");
    if (!toggleIcon) return;

    if (isExpanded) {
      toggleIcon.src =
        "https://www.figma.com/api/mcp/asset/3ca3e661-55ea-479b-a092-686bd6efa3c2";
      toggleIcon.alt = "Collapse";
    } else {
      toggleIcon.src =
        "https://www.figma.com/api/mcp/asset/d32557b0-3c99-46f2-ab14-4f78807e74de";
      toggleIcon.alt = "Expand";
    }
  }

  slideDown(element) {
    if (!element) return;
    element.style.display = "flex";
    element.style.maxHeight = "none";
    const height = element.offsetHeight;
    element.style.maxHeight = "0";
    element.style.overflow = "hidden";
    element.style.transition = "max-height 0.3s ease";

    requestAnimationFrame(() => {
      element.style.maxHeight = height + "px";
    });

    setTimeout(() => {
      element.style.maxHeight = "none";
      element.style.overflow = "visible";
    }, 300);
  }

  slideUp(element) {
    if (!element) return;
    element.style.maxHeight = element.offsetHeight + "px";
    element.style.overflow = "hidden";
    element.style.transition = "max-height 0.3s ease";

    requestAnimationFrame(() => {
      element.style.maxHeight = "0";
    });

    setTimeout(() => {
      element.style.display = "none";
    }, 300);
  }

  handleThumbnailClick(e) {
    e.preventDefault();
    const thumbnail = e.currentTarget;
    const thumbnailImage = thumbnail.querySelector(
      ".atc-bundle-sor__thumbnail-image"
    );

    if (thumbnailImage && this.mainImage) {
      this.thumbnails.forEach((thumb) => {
        thumb.classList.remove("atc-bundle-sor__thumbnail--active");
      });

      thumbnail.classList.add("atc-bundle-sor__thumbnail--active");

      const newImageSrc = thumbnailImage.dataset.imageSrc || thumbnailImage.src;
      if (newImageSrc && this.mainImage.tagName === "IMG") {
        this.mainImage.src = newImageSrc;
        this.mainImage.alt = thumbnailImage.alt;
      }
    }

    this.trackThumbnailClick();
  }

  handleMobilePrevClick() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  handleMobileNextClick() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  initializeBenefitsShowMore() {
    const expandableSections = this.container.querySelectorAll(
      ".atc-bundle-sor__expandable-block"
    );

    expandableSections.forEach((section) => {
      const sectionTitle = section.querySelector(
        ".atc-bundle-sor__block-title"
      );
      if (sectionTitle && sectionTitle.textContent.includes("Bénéfices")) {
        const content = section.querySelector(".atc-bundle-sor__block-content");
        const seeMoreBtn = section.querySelector(
          ".atc-bundle-sor__see-more-btn"
        );

        if (content) {
          const allItems = content.querySelectorAll(
            ".atc-bundle-sor__content-item"
          );
          const hiddenItems = content.querySelectorAll(
            ".atc-bundle-sor__content-item--hidden"
          );

          if (hiddenItems.length === 0) {
            if (seeMoreBtn) {
              seeMoreBtn.style.display = "none";
            }
          }
        }
      }
    });
  }

  handleSeeMoreClick(e, section) {
    e.preventDefault();
    e.stopPropagation();

    const button = e.currentTarget;
    const content = section.querySelector(".atc-bundle-sor__block-content");

    if (!content) return;

    const sectionTitle = section.querySelector(".atc-bundle-sor__block-title");
    if (sectionTitle && sectionTitle.textContent.includes("Bénéfices")) {
      const hiddenItems = content.querySelectorAll(
        ".atc-bundle-sor__content-item--hidden"
      );

      let isExpanded = button.textContent.trim() === "Voir moins";

      if (!isExpanded) {
        hiddenItems.forEach((item) => {
          item.style.display = "flex";
        });
        button.textContent = "Voir moins";
      } else {
        hiddenItems.forEach((item) => {
          item.style.display = "none";
        });
        button.textContent = "Voir plus";
      }
    } else {
      const hiddenBenefits = section.querySelector(
        ".atc-bundle-sor__benefits-hidden"
      );
      if (hiddenBenefits) {
        if (hiddenBenefits.style.display === "none") {
          hiddenBenefits.style.display = "block";
          button.textContent = "Voir moins";
        } else {
          hiddenBenefits.style.display = "none";
          button.textContent = "Voir plus";
        }
      }
    }

    this.trackSeeMoreClick(button.textContent);
  }

  handleInfoButtonClick(e) {
    e.preventDefault();
    const button = e.currentTarget;
    const buttonText = button.textContent.trim();

    if (buttonText.includes("Guide")) {
      this.showUsageGuide();
    } else if (buttonText.includes("différence")) {
      this.showDifference();
    }

    this.trackInfoButtonClick(buttonText);
  }

  showUsageGuide() {
    const modalOverlay = this.container.querySelector(
      '[data-modal-type="guide_utilisation"]'
    );

    if (modalOverlay) {
      modalOverlay.style.display = "flex";
      modalOverlay.style.alignItems = "center";
      modalOverlay.style.justifyContent = "center";

      this.bindGuideModalEvents(modalOverlay);

      this.trackModalOpen("guide_utilisation");
    } else {
    }
  }

  bindGuideModalEvents(modalOverlay) {
    if (modalOverlay.dataset.eventsAttached === "true") {
      return;
    }

    const closeBtn = modalOverlay.querySelector(
      ".atc-bundle-sor__guide-close-btn"
    );
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        this.closeGuideModal(modalOverlay);
      });
    }

    const categoryBtns = modalOverlay.querySelectorAll(
      ".atc-bundle-sor__category-btn"
    );
    categoryBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        this.handleCategoryChange(e, modalOverlay);
      });
    });

    modalOverlay.addEventListener("click", (e) => {
      if (e.target === modalOverlay) {
        this.closeGuideModal(modalOverlay);
      }
    });

    const handleEscape = (e) => {
      if (e.key === "Escape") {
        this.closeGuideModal(modalOverlay);
        document.removeEventListener("keydown", handleEscape);
      }
    };
    document.addEventListener("keydown", handleEscape);

    modalOverlay.dataset.eventsAttached = "true";
  }

  handleCategoryChange(e, modalOverlay) {
    e.preventDefault();
    const clickedBtn = e.currentTarget;
    const category = clickedBtn.dataset.category;

    const allBtns = modalOverlay.querySelectorAll(
      ".atc-bundle-sor__category-btn"
    );
    allBtns.forEach((btn) =>
      btn.classList.remove("atc-bundle-sor__category-btn--active")
    );
    clickedBtn.classList.add("atc-bundle-sor__category-btn--active");

    this.updateGuideContent(modalOverlay, category);

    this.trackCategorySwitch(category);
  }

  updateGuideContent(modalOverlay, category) {
    const title = modalOverlay.dataset[`${category}Title`] || "";
    const description = modalOverlay.dataset[`${category}Description`] || "";
    const duration = modalOverlay.dataset[`${category}Duration`] || "";
    const benefitsHtml = modalOverlay.dataset[`${category}Benefits`] || "";
    const imageSrc = modalOverlay.dataset[`${category}Image`] || "";

    let benefits = [];
    if (benefitsHtml) {
      const benefitsText = benefitsHtml.replace(/<p>/g, "").split("</p>");
      benefits = benefitsText.filter((b) => b.trim() !== "");
    }

    const titleElement = modalOverlay.querySelector(
      ".atc-bundle-sor__guide-category-title"
    );
    if (titleElement) titleElement.textContent = title;

    const descriptionElement = modalOverlay.querySelector(
      ".atc-bundle-sor__guide-description"
    );
    if (descriptionElement) descriptionElement.innerHTML = description;

    if (imageSrc) {
      const imageElement = modalOverlay.querySelector(
        ".atc-bundle-sor__guide-main-image"
      );
      if (imageElement) {
        imageElement.src = imageSrc;
        imageElement.alt = title;
      }
    }

    const benefitsList = modalOverlay.querySelector(
      ".atc-bundle-sor__guide-benefits-list"
    );
    if (benefitsList && benefits.length > 0) {
      benefitsList.innerHTML = "";
      benefits.forEach((benefit) => {
        const benefitItem = document.createElement("div");
        benefitItem.className = "atc-bundle-sor__guide-benefit-item";
        benefitItem.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="atc-bundle-sor__guide-check-icon">
            <path d="M12 5.33301L7.08361 10.3059C6.8876 10.5042 6.5673 10.5038 6.37172 10.3051L4 7.89578" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span class="atc-bundle-sor__guide-benefit-text">${benefit.trim()}</span>
        `;
        benefitsList.appendChild(benefitItem);
      });
    }

    const durationElement = modalOverlay.querySelector(
      ".atc-bundle-sor__guide-duration-badge"
    );
    if (durationElement) durationElement.textContent = duration;
  }

  closeGuideModal(modalOverlay) {
    if (modalOverlay) {
      this.closeModal(modalOverlay);
      this.trackModalClose("guide_utilisation");
    }
  }

  trackModalOpen(modalType) {}

  trackModalClose(modalType) {}

  trackCategorySwitch(category) {}

  showDifference() {}

  showAddToCartSuccess() {
    this.showNotification("Produit ajouté au panier !", "success");
  }

  showAddToCartError() {
    this.showNotification("Erreur lors de l'ajout au panier", "error");
  }

  showPackAddSuccess() {
    this.showNotification("Pack Routine ajouté au panier !", "success");
  }

  showPackAddError() {
    this.showNotification("Erreur lors de l'ajout du pack", "error");
  }

  showNotification(message, type = "info") {
    const notification = document.createElement("div");
    notification.className = `atc-bundle-sor__notification atc-bundle-sor__notification--${type}`;
    notification.textContent = message;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.remove();
    }, 3000);
  }

  async updateCartCount() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();

      const cartCount = document.querySelector(".cart-count");
      if (cartCount) {
        cartCount.textContent = cart.item_count;
      }
    } catch (error) {}
  }

  trackFrequencySelection(frequency) {
    if (typeof gtag !== "undefined") {
      gtag("event", "frequency_selection", {
        frequency_type: frequency,
        section: "atc-bundle-sor",
      });
    }
  }

  trackPeriodChange(sellingPlanId) {
    if (typeof gtag !== "undefined") {
      gtag("event", "period_change", {
        selling_plan_id: sellingPlanId,
        section: "atc-bundle-sor",
      });
    }
  }

  trackAddToCart(variantId, frequency) {
    if (typeof gtag !== "undefined") {
      gtag("event", "add_to_cart", {
        variant_id: variantId,
        frequency: frequency,
        section: "atc-bundle-sor",
      });
    }
  }

  trackPackRoutineAdd() {
    if (typeof gtag !== "undefined") {
      gtag("event", "pack_routine_add", {
        section: "atc-bundle-sor",
      });
    }
  }

  trackSectionToggle(section, isExpanded) {
    const sectionTitle = section.querySelector("h3")?.textContent || "unknown";

    if (typeof gtag !== "undefined") {
      gtag("event", "section_toggle", {
        section_name: sectionTitle,
        is_expanded: isExpanded,
        component: "atc-bundle-sor",
      });
    }
  }

  trackThumbnailClick() {
    if (typeof gtag !== "undefined") {
      gtag("event", "thumbnail_click", {
        section: "atc-bundle-sor",
      });
    }
  }

  trackSeeMoreClick(buttonText) {
    if (typeof gtag !== "undefined") {
      gtag("event", "see_more_click", {
        button_text: buttonText,
        section: "atc-bundle-sor",
      });
    }
  }

  trackInfoButtonClick(buttonText) {
    if (typeof gtag !== "undefined") {
      gtag("event", "info_button_click", {
        button_text: buttonText,
        section: "atc-bundle-sor",
      });
    }
  }

  handleVariantSelection(e) {
    e.preventDefault();
    const selectedOption = e.currentTarget;
    const variantId = selectedOption.dataset.variantId;
    const variantPrice = selectedOption.dataset.variantPrice;
    const variantTitle = selectedOption.dataset.variantTitle;

    if (!variantId) return;

    this.currentVariantId = variantId;
    this.currentVariantPrice = parseFloat(variantPrice);

    this.updateVariantSelection(selectedOption);

    this.updateCtaVariant(variantId, variantPrice);

    this.updateSellingPlansForVariant(variantId);

    this.updatePricing();

    this.updateSubscriptionDisplay();

    this.updateVariantSavingsBadges();

    this.updateSubscriptionInfo(variantId);

    this.syncStickyVariantWithMain(variantId);

    this.trackVariantSelection(variantId, variantTitle);
  }

  updateVariantSelection(selectedOption) {
    this.variantOptions.forEach((option) => {
      option.classList.remove("atc-bundle-sor__variant-option--selected");
    });

    selectedOption.classList.add("atc-bundle-sor__variant-option--selected");

    this.updateDefaultSellingPlanOption(selectedOption);
  }

  updateDefaultSellingPlanOption(selectedOption) {
    const defaultSellingPlanIndex = parseInt(selectedOption.dataset.defaultSellingPlanIndex) - 1;

    const allSellingPlanOptions = this.container.querySelectorAll(".atc-bundle-sor__period-option");
    const defaultSellingPlanOptionButton = allSellingPlanOptions[defaultSellingPlanIndex];

    if (defaultSellingPlanOptionButton) {
      setTimeout(() => {
        this.handlePeriodChange(null, defaultSellingPlanOptionButton);
      }, 500);
    }
  }

  updateStockDisplay() {
    const baseStock = parseInt(this.container.dataset.baseStock) || 0;
    const totalInventory = parseInt(this.container.dataset.totalInventory) || 0;

    if (baseStock === 0) {
      return;
    }

    const stockPercentage = Math.round(
      ((baseStock - totalInventory) / baseStock) * 100
    );

    const stockNumbers = this.container.querySelector(
      ".atc-bundle-sor__stock-left span:last-child"
    );
    if (stockNumbers) {
      stockNumbers.innerHTML = `<strong>${totalInventory}</strong> / ${baseStock} unités`;
    }

    const stockPercentageEl = this.container.querySelector(
      ".atc-bundle-sor__stock-percentage"
    );
    if (stockPercentageEl) {
      stockPercentageEl.textContent = `${stockPercentage}% réservé`;
    }

    const stockProgress = this.container.querySelector(
      ".atc-bundle-sor__stock-progress"
    );
    if (stockProgress) {
      stockProgress.style.width = `${stockPercentage}%`;
    }

    const stickyProgress = this.container.querySelector(
      ".atc-bundle-sor__sticky-progress-fill"
    );
    if (stickyProgress) {
      stickyProgress.style.width = `${stockPercentage}%`;
    }

    const stickyStockText = this.container.querySelector(
      ".atc-bundle-sor__sticky-stock-text"
    );
    if (stickyStockText) {
      stickyStockText.textContent = `${stockPercentage}% réservé`;
    }
  }

  updateSubscriptionInfo(variantId) {
    const subscriptionAlertBlock = this.container.querySelector(
      "[data-subscription-alert]"
    );
    const subscriptionAlertContent = this.container.querySelector(
      "[data-subscription-alert-content]"
    );

    if (!subscriptionAlertBlock || !subscriptionAlertContent) {
      return;
    }

    if (!window.variantData || !window.variantData[variantId]) {
      subscriptionAlertBlock.style.display = "none";
      return;
    }

    const variant = window.variantData[variantId];

    const metafieldValue =
      variant.metafields?.custom?.v2_discover_subscription_information;

    if (metafieldValue && metafieldValue.trim() !== "") {
      subscriptionAlertContent.textContent = metafieldValue;
      subscriptionAlertBlock.style.display = "flex";
    } else {
      subscriptionAlertBlock.style.display = "none";
    }
  }

  updateCtaVariant(variantId, variantPrice) {
    if (this.ctaButton) {
      this.ctaButton.dataset.variantId = variantId;
    }

    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      let variantInput = productForm.querySelector('input[name="id"]');
      if (!variantInput) {
        variantInput = document.createElement("input");
        variantInput.type = "hidden";
        variantInput.name = "id";
        productForm.appendChild(variantInput);
      }
      variantInput.value = variantId;
    }
  }

  updateSellingPlansForVariant(variantId) {
    const variantSellingPlans = {};

    const isSubscription = this.isSubscriptionSelected();

    Object.keys(this.sellingPlansData).forEach((uniqueKey) => {
      const planData = this.sellingPlansData[uniqueKey];
      if (
        planData.variant_id &&
        planData.variant_id.toString() === variantId.toString()
      ) {
        variantSellingPlans[uniqueKey] = planData;
      }
    });

    if (Object.keys(variantSellingPlans).length === 0) return;

    if (this.currentSellingPlanId) {
      const currentPlanExists = Object.keys(variantSellingPlans).some((key) => {
        const planData = variantSellingPlans[key];
        return (
          (planData.selling_plan_id || planData.id) ===
          this.currentSellingPlanId
        );
      });

      if (!currentPlanExists) {
        const firstPlanKey = Object.keys(variantSellingPlans)[0];
        if (firstPlanKey) {
          const firstPlan = variantSellingPlans[firstPlanKey];
          this.currentSellingPlanId = firstPlan.selling_plan_id || firstPlan.id;
        }
      }
    } else if(isSubscription) {
      const firstPlanKey = Object.keys(variantSellingPlans)[0];
      if (firstPlanKey) {
        const firstPlan = variantSellingPlans[firstPlanKey];
        
        this.currentSellingPlanId = firstPlan.selling_plan_id || firstPlan.id;
      }
    }
  }

  trackVariantSelection(variantId, variantTitle) {
    if (typeof gtag !== "undefined") {
      gtag("event", "variant_selection", {
        variant_id: variantId,
        variant_title: variantTitle,
        section: "atc-bundle-sor",
      });
    }
  }

  initializeModals() {
    this.modals = document.querySelectorAll(".atc-bundle-sor__modal-overlay");

    this.initializeComparisonModal();

    this.isSwiperInteracting = false;
    this.swiperInteractionTimeout = null;

    this.modals.forEach((modal) => {
      const closeButtons = modal.querySelectorAll(
        ".atc-bundle-sor__modal-close, .atc-bundle-sor__guide-close-btn"
      );
      closeButtons.forEach(closeBtn => {
        closeBtn.addEventListener("click", () => this.closeModal(modal));
      });

      modal.addEventListener("click", (e) => {
        if (e.target === modal && !this.isSwiperInteracting) {
          this.closeModal(modal);
        }
      });

      modal.addEventListener("mousedown", (e) => {
        const swiperElement = e.target.closest(".atc-bundle-sor__swiper");
        if (swiperElement) {
          this.isSwiperInteracting = true;
        }
      });

      modal.addEventListener("mouseup", () => {
        this.resetSwiperInteraction();
      });

      modal.addEventListener("touchstart", (e) => {
        const swiperElement = e.target.closest(".atc-bundle-sor__swiper");
        if (swiperElement) {
          this.isSwiperInteracting = true;
        }
      });

      modal.addEventListener("touchend", () => {
        this.resetSwiperInteraction();
      });
    });
  }

  openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.add("active");
      document.body.style.overflow = "hidden";

      const modalType = modal.dataset.modalType;
      if (modalType === "guide_utilisation") {
        if (modal.dataset.useUsageShowcase === "true") {
          this.loadUsageShowcaseContent(modal);
        }
        this.bindGuideModalEvents(modal);
      }

      if (
        modalType === "before_after" &&
        modal.dataset.useResultsShowcase === "true"
      ) {
        // Load content FIRST (injects new DOM elements)
        this.loadResultsShowcaseContent(modal);

        // THEN reset flags on the NEW elements
        const swiperElement = modal.querySelector(".atc-bundle-sor__swiper");
        if (swiperElement) {
          swiperElement.dataset.swiperInitialized = "false";
        }

        // Reset flags on NEW slider handles (after content injection) - search for BOTH class variants
        const sliderHandles = modal.querySelectorAll(
          ".atc-bundle-sor__slider-handle, .results-showcase__slider-handle"
        );
        sliderHandles.forEach((handle, index) => {
          handle.dataset.initialized = "false";
          handle.removeAttribute("data-initialized");
        });
      }

      if (modalType === "composition") {
        this.loadCompositionContent(modal);
      }

      setTimeout(() => {
        this.initializeModalSwipers(modal);
        // Prevent swiper from intercepting before/after slider events
        this.preventSwiperOnBeforeAfter(modal);
      }, 100);
    } else {
    }
  }

  closeModal(modal) {
    modal.classList.add("closing");

    setTimeout(() => {
      modal.classList.remove("active");
      modal.classList.remove("closing");
      document.body.style.overflow = "";
    }, 300);

    if (this.swiperInteractionTimeout) {
      clearTimeout(this.swiperInteractionTimeout);
      this.swiperInteractionTimeout = null;
    }
    this.isSwiperInteracting = false;
  }

  loadResultsShowcaseContent(modal) {
    const resultsShowcaseSection = document.querySelector(
      '[data-section-type="results-showcase"] .desktop-only'
    );

    if (!resultsShowcaseSection) {
      return;
    }

    const showcaseCards = resultsShowcaseSection.querySelectorAll(
      ".results-showcase__card"
    );

    if (showcaseCards.length === 0) {
      return;
    }

    const swiperWrapper = modal.querySelector(".swiper-wrapper");

    if (!swiperWrapper) {
      return;
    }

    swiperWrapper.innerHTML = "";

    showcaseCards.forEach((card, index) => {
      const slide = document.createElement("div");
      slide.className = "swiper-slide atc-bundle-sor__slide";

      // Look for image-container (not before-after-container)
      const beforeAfterContainer = card.querySelector(
        ".results-showcase__image-container"
      );

      if (beforeAfterContainer) {
        const clonedContainer = beforeAfterContainer.cloneNode(true);

        // Add the main container class for noSwiping
        clonedContainer.classList.add("atc-bundle-sor__image-container");

        // Remap all results-showcase classes to atc-bundle-sor classes
        const sliderContainer = clonedContainer.querySelector(
          ".results-showcase__slider-container"
        );
        if (sliderContainer) {
          sliderContainer.classList.add("atc-bundle-sor__slider-container");
        }

        const sliderHandle = clonedContainer.querySelector(
          ".results-showcase__slider-handle"
        );
        if (sliderHandle) {
          sliderHandle.classList.add("atc-bundle-sor__slider-handle");
        }

        const sliderLine = clonedContainer.querySelector(
          ".results-showcase__slider-line"
        );
        if (sliderLine) {
          sliderLine.classList.add("atc-bundle-sor__slider-line");
        }

        const beforeImage = clonedContainer.querySelector(
          ".results-showcase__before-image"
        );
        if (beforeImage) {
          beforeImage.classList.add("atc-bundle-sor__before-image");
        }

        const afterImage = clonedContainer.querySelector(
          ".results-showcase__after-image"
        );
        if (afterImage) {
          afterImage.classList.add("atc-bundle-sor__after-image");
        }

        slide.appendChild(clonedContainer);
      } else {
        const cardContent = card.cloneNode(true);
        slide.appendChild(cardContent);
      }

      swiperWrapper.appendChild(slide);
    });
  }

  loadUsageShowcaseContent(modal) {
    const usageShowcaseSection = document.querySelector(
      '[data-section-type="usage-showcase"]'
    );

    if (!usageShowcaseSection) {
      return;
    }

    const usageCards = usageShowcaseSection.querySelectorAll(
      ".usage-showcase__card"
    );

    if (usageCards.length === 0) {
      return;
    }

    const categoryButtons = modal.querySelectorAll(
      ".atc-bundle-sor__category-btn"
    );
    const categoriesData = [];

    usageCards.forEach((card, index) => {
      const filterBtn = usageShowcaseSection.querySelector(
        `[data-slide-index="${index}"]`
      );
      const categoryName = filterBtn
        ? filterBtn.textContent.trim().toLowerCase()
        : "";

      const image = card.querySelector(".usage-showcase__image");
      const imageSrc = image ? image.src : "";

      const title = card.querySelector(".usage-showcase__content-title");
      const titleText = title ? title.textContent.trim() : "";

      const description = card.querySelector(".usage-showcase__description");
      const descriptionText = description ? description.innerHTML : "";

      const duration = card.querySelector(".usage-showcase__duration-badge");
      const durationText = duration ? duration.textContent.trim() : "";

      const benefits = [];
      const contentType = card.querySelector(".usage-showcase__stats")
        ? "stats"
        : "checks";

      if (contentType === "stats") {
        const stats = card.querySelectorAll(".usage-showcase__stat");
        stats.forEach((stat) => {
          const number = stat.querySelector(".usage-showcase__stat-number");
          const desc = stat.querySelector(".usage-showcase__stat-description");
          if (number && desc) {
            benefits.push(
              `${number.textContent.trim()} - ${desc.textContent.trim()}`
            );
          }
        });
      } else {
        const checks = card.querySelectorAll(".usage-showcase__check-item");
        checks.forEach((check) => {
          const text = check.querySelector(".usage-showcase__check-text");
          if (text) {
            benefits.push(text.textContent.trim());
          }
        });
      }

      categoriesData.push({
        name: categoryName,
        image: imageSrc,
        title: titleText,
        description: descriptionText,
        duration: durationText,
        benefits: benefits,
        contentType: contentType,
      });
    });

    const categoryMap = {
      corps: categoriesData[0] || null,
      visage: categoriesData[1] || null,
      cheveux: categoriesData[2] || null,
      ongles: categoriesData[3] || null,
    };

    categoryButtons.forEach((btn, index) => {
      const category = btn.dataset.category;
      const data = categoryMap[category];

      if (data) {
        btn.textContent = data.title;

        modal.dataset[`${category}Title`] = data.title;
        modal.dataset[`${category}Description`] = data.description;
        modal.dataset[`${category}Duration`] = data.duration;

        const benefitsHtml = data.benefits.map((b) => `<p>${b}</p>`).join("");
        modal.dataset[`${category}Benefits`] = benefitsHtml;

        if (data.image) {
          modal.dataset[`${category}Image`] = data.image;
        }
      }
    });

    this.updateGuideContent(modal, "corps");
  }

  resetSwiperInteraction() {
    if (this.swiperInteractionTimeout) {
      clearTimeout(this.swiperInteractionTimeout);
    }

    this.swiperInteractionTimeout = setTimeout(() => {
      this.isSwiperInteracting = false;
      this.swiperInteractionTimeout = null;
    }, 1000);
  }

  checkIngredientsSection() {
    const ingredientsSection = document.querySelector(
      '[data-section-type="ingredients-vsor"]'
    );
    const compositionBtn = this.container.querySelector(
      ".atc-bundle-sor__composition-btn"
    );

    if (compositionBtn) {
      if (ingredientsSection) {
        compositionBtn.style.display = "inline";
      } else {
        compositionBtn.style.display = "none";
      }
    }
  }

  loadCompositionContent(modal) {
    const ingredientsSection = document.querySelector(
      '[data-section-type="ingredients-vsor"]'
    );

    if (!ingredientsSection) {
      return;
    }

    const ingredientCards = ingredientsSection.querySelectorAll(
      ".ingredients-vsor__card"
    );

    if (ingredientCards.length === 0) {
      return;
    }

    const ingredientsContainer = modal.querySelector(
      ".atc-bundle-sor__composition-ingredients"
    );

    if (!ingredientsContainer) {
      return;
    }

    ingredientsContainer.innerHTML = "";

    ingredientCards.forEach((card, index) => {
      const ingredientItem = document.createElement("div");
      ingredientItem.className = "atc-bundle-sor__composition-item";

      const image = card.querySelector(".ingredients-vsor__image");
      const title = card.querySelector(".ingredients-vsor__card-title");
      const description = card.querySelector(".ingredients-vsor__description");

      if (image && title && description) {
        const itemImage = document.createElement("div");
        itemImage.className = "atc-bundle-sor__composition-image";
        const imgClone = image.cloneNode(true);
        itemImage.appendChild(imgClone);

        const itemContent = document.createElement("div");
        itemContent.className = "atc-bundle-sor__composition-text";

        const itemTitle = document.createElement("h3");
        itemTitle.className = "atc-bundle-sor__composition-title p-medium";
        itemTitle.textContent = title.textContent;

        const itemDescription = document.createElement("div");
        itemDescription.className =
          "atc-bundle-sor__composition-description p-small";
        itemDescription.innerHTML = description.innerHTML;

        itemContent.appendChild(itemTitle);
        itemContent.appendChild(itemDescription);

        ingredientItem.appendChild(itemImage);
        ingredientItem.appendChild(itemContent);

        ingredientsContainer.appendChild(ingredientItem);
      }
    });
  }

  initializeComparisonModal() {
    const comparisonModals = document.querySelectorAll(
      '[data-modal-type="comparison_table"]'
    );

    comparisonModals.forEach((modal) => {
      const contentContainer = modal.querySelector(
        ".atc-bundle-sor__comparison-content"
      );

      if (contentContainer) {
        if (contentContainer.children.length > 0) {
          return;
        }

        const comparisonSections = document.querySelectorAll(
          '[data-section-type="comparaison-table-2"]'
        );

        const firstSection = comparisonSections[0];

        if (firstSection) {
          const comparisonContent = firstSection.querySelector(
            ".comparaison-table-2__container"
          );

          if (comparisonContent) {
            const clonedContent = comparisonContent.cloneNode(true);
            contentContainer.appendChild(clonedContent);
          }
        }
      }

      this.initializeComparisonSwitcher(modal);
    });
  }

  initializeComparisonSwitcher(modal) {
    const hasBlackFridayHeader = document.querySelector('.w-blackfriday-header');

    if (!hasBlackFridayHeader) {
      return;
    }

    const filterButtons = modal.querySelectorAll('.atc-bundle-sor__comparison-filter-btn');
    const contentContainer = modal.querySelector('.atc-bundle-sor__comparison-content');

    if (!filterButtons.length || !contentContainer) {
      return;
    }

    const comparisonSections = document.querySelectorAll('[data-section-type="comparaison-table-2"]');

    filterButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        filterButtons.forEach(btn => btn.classList.remove('atc-bundle-sor__comparison-filter-btn--active'));
        button.classList.add('atc-bundle-sor__comparison-filter-btn--active');

        const productFilter = button.dataset.productFilter;

        let targetSection;
        if (productFilter === 'anti-rides') {
          targetSection = comparisonSections[0];
        } else if (productFilter === 'demaquillante') {
          targetSection = comparisonSections[1];
        }

        if (targetSection) {
          const comparisonContent = targetSection.querySelector('.comparaison-table-2__container');

          if (comparisonContent) {
            contentContainer.innerHTML = '';
            const clonedContent = comparisonContent.cloneNode(true);
            contentContainer.appendChild(clonedContent);
          }
        }
      });
    });
  }

  connectInfoButtonsToModals() {
    this.infoButtons.forEach((button) => {
      if (button.hasAttribute("data-modal-trigger")) {
        return;
      }

      const buttonText = button.textContent.trim();

      this.modals.forEach((modal) => {
        const modalId = modal.id;

        if (
          buttonText.includes("différence") ||
          buttonText.includes("Notre différence")
        ) {
          button.addEventListener("click", (e) => {
            e.preventDefault();
            this.openModal(modalId);
            this.trackModalOpen("before_after", buttonText);
          });
        }
      });
    });
  }

  initializeInfoButtons() {
    const infoButtonsWithTriggers = document.querySelectorAll(
      "[data-modal-trigger]"
    );

    infoButtonsWithTriggers.forEach((button) => {
      const modalId = button.dataset.modalTrigger;

      button.addEventListener("click", (e) => {
        e.preventDefault();

        const targetModal = document.getElementById(modalId);

        if (targetModal) {
          this.openModal(targetModal.id);
          this.trackModalOpen(modalId, button.textContent.trim());
        } else {
        }
      });
    });
  }

  initializeModalSwipers(modal = null) {
    const searchScope = modal || document;
    const modalSwipers = searchScope.querySelectorAll(
      ".atc-bundle-sor__swiper"
    );

    modalSwipers.forEach((swiperElement) => {
      if (swiperElement.dataset.swiperInitialized === "true") {
        return;
      }

      if (typeof Swiper !== "undefined") {
        const totalSlides =
          swiperElement.querySelectorAll(".swiper-slide").length;

        const swiper = new Swiper(swiperElement, {
          slidesPerView: 1.2,
          spaceBetween: 12,
          centeredSlides: true,
          loop: false,
          grabCursor: true,
          noSwiping: true,
          noSwipingClass: "atc-bundle-sor__image-container",
          breakpoints: {
            768: {
              slidesPerView: 1.2,
              spaceBetween: 12,
              centeredSlides: true,
            },
            1024: {
              slidesPerView: 1.2,
              spaceBetween: 12,
              centeredSlides: true,
            },
          },
          navigation: {
            nextEl: ".atc-bundle-sor__nav-next",
            prevEl: ".atc-bundle-sor__nav-prev",
          },
          pagination: {
            el: ".atc-bundle-sor__pagination",
            clickable: true,
            dynamicBullets: false,
            renderBullet: function (index, className) {
              return '<span class="' + className + '"></span>';
            },
          },
          a11y: {
            prevSlideMessage: "Review précédente",
            nextSlideMessage: "Review suivante",
            firstSlideMessage: "Première review",
            lastSlideMessage: "Dernière review",
          },
          watchSlidesProgress: true,
          watchSlidesVisibility: true,
          on: {
            init: () => {
              this.updateModalPaginationVisibility(totalSlides);
              setTimeout(() => {
                this.initializeModalBeforeAfter();
              }, 200);
            },
            slideChange: () => {},
            breakpoint: () => {
              this.updateModalPaginationVisibility(totalSlides);
            },
            touchStart: () => {
              this.isSwiperInteracting = true;
            },
            touchEnd: () => {
              this.resetSwiperInteraction();
            },
            sliderMove: () => {
              this.isSwiperInteracting = true;
            },
            transitionStart: () => {
              this.isSwiperInteracting = true;
            },
            transitionEnd: () => {
              this.resetSwiperInteraction();
            },
          },
        });

        this.modalSwiper = swiper;

        swiperElement.dataset.swiperInitialized = "true";
      }
    });
  }

  updateModalPaginationVisibility(totalSlides) {
    const paginationElement = document.querySelector(
      ".atc-bundle-sor__modal .atc-bundle-sor__pagination"
    );
    if (!paginationElement) return;
    const windowWidth = window.innerWidth;
    let shouldHidePagination = false;

    if (windowWidth >= 1024) {
      shouldHidePagination = totalSlides <= 1;
    } else if (windowWidth >= 768) {
      shouldHidePagination = totalSlides <= 1;
    } else {
      shouldHidePagination = totalSlides <= 1;
    }

    if (shouldHidePagination) {
      paginationElement.style.display = "none";
    } else {
      paginationElement.style.display = "flex";
    }
  }

  initializeModalBeforeAfter() {
    const slides = document.querySelectorAll(
      ".atc-bundle-sor__modal .atc-bundle-sor__slide"
    );

    slides.forEach((slide, index) => {
      const sliderHandle = slide.querySelector(
        ".atc-bundle-sor__slider-handle"
      );

      if (sliderHandle && sliderHandle.dataset.initialized === "true") {
        return;
      }

      this.setupModalBeforeAfterInteraction(slide, index);
    });
  }

  setupModalBeforeAfterInteraction(slide, slideIndex) {
    const sliderHandle = slide.querySelector(
      ".atc-bundle-sor__slider-handle, .results-showcase__slider-handle"
    );
    const sliderContainer = slide.querySelector(
      ".atc-bundle-sor__slider-container, .results-showcase__slider-container"
    );
    const afterImage = slide.querySelector(
      ".atc-bundle-sor__after-image, .results-showcase__after-image"
    );
    const sliderLine = slide.querySelector(
      ".atc-bundle-sor__slider-line, .results-showcase__slider-line"
    );

    if (!sliderHandle || !sliderContainer || !afterImage || !sliderLine) {
      return;
    }

    if (!this.modalSlidersState) {
      this.modalSlidersState = {};
    }

    if (!this.modalSlidersState[slideIndex]) {
      this.modalSlidersState[slideIndex] = {
        isDragging: false,
        wasDragging: false,
        currentPosition: 50,
      };
    }

    this.updateModalSliderPosition(
      sliderHandle,
      sliderLine,
      afterImage,
      this.modalSlidersState[slideIndex].currentPosition,
      slideIndex
    );
    sliderHandle.dataset.initialized = "true";

    const handleMouseDown = (e) => {
      this.modalSlidersState[slideIndex].isDragging = true;
      this.isSwiperInteracting = true;
      sliderHandle.style.cursor = "grabbing";
      document.body.style.userSelect = "none";
      sliderHandle.style.transform = "translate(-50%, -50%) scale(1.1)";
      if (this.modalSwiper) {
        this.modalSwiper.disable();
        this.modalSwiper.allowTouchMove = false;
      }

      e.preventDefault();
      e.stopPropagation();
    };

    const handleMouseMove = (e) => {
      if (!this.modalSlidersState[slideIndex].isDragging) return;
      this.handleModalSliderMove(
        e.clientX,
        sliderContainer,
        sliderHandle,
        sliderLine,
        afterImage,
        slideIndex
      );
      e.preventDefault();
    };

    const handleMouseUp = () => {
      if (this.modalSlidersState[slideIndex].isDragging) {
        this.modalSlidersState[slideIndex].isDragging = false;
        this.modalSlidersState[slideIndex].wasDragging = true;
        sliderHandle.style.cursor = "grab";
        document.body.style.userSelect = "";
        sliderHandle.style.transform = "translate(-50%, -50%) scale(1)";

        setTimeout(() => {
          if (this.modalSlidersState[slideIndex]) {
            this.modalSlidersState[slideIndex].wasDragging = false;
          }
        }, 100);

        this.resetSwiperInteraction();

        if (this.modalSwiper) {
          this.modalSwiper.enable();
          this.modalSwiper.allowTouchMove = true;
        }
      }
    };

    // Add listeners with capture:true to intercept before Swiper
    sliderHandle.addEventListener("mousedown", handleMouseDown, {
      capture: true,
    });
    document.addEventListener("mousemove", handleMouseMove, { capture: true });
    document.addEventListener("mouseup", handleMouseUp, { capture: true });

    const handleTouchStart = (e) => {
      this.modalSlidersState[slideIndex].isDragging = true;
      this.isSwiperInteracting = true;
      if (this.modalSwiper) {
        this.modalSwiper.disable();
        this.modalSwiper.allowTouchMove = false;
      }
      e.preventDefault();
      e.stopPropagation();
    };

    const handleTouchMove = (e) => {
      if (!this.modalSlidersState[slideIndex].isDragging) return;
      this.handleModalSliderMove(
        e.touches[0].clientX,
        sliderContainer,
        sliderHandle,
        sliderLine,
        afterImage,
        slideIndex
      );
      e.preventDefault();
    };

    const handleTouchEnd = () => {
      if (this.modalSlidersState[slideIndex].isDragging) {
        this.modalSlidersState[slideIndex].isDragging = false;
        this.modalSlidersState[slideIndex].wasDragging = true;

        setTimeout(() => {
          if (this.modalSlidersState[slideIndex]) {
            this.modalSlidersState[slideIndex].wasDragging = false;
          }
        }, 150);

        this.resetSwiperInteraction();

        if (this.modalSwiper) {
          this.modalSwiper.enable();
          this.modalSwiper.allowTouchMove = true;
        }
      }
    };

    // Add listeners with capture:true to intercept before Swiper
    sliderHandle.addEventListener("touchstart", handleTouchStart, {
      passive: false,
      capture: true,
    });
    document.addEventListener("touchmove", handleTouchMove, {
      passive: false,
      capture: true,
    });
    document.addEventListener("touchend", handleTouchEnd, { capture: true });
  }

  handleModalSliderMove(
    clientX,
    container,
    handle,
    line,
    afterImage,
    slideIndex
  ) {
    const containerRect = container.getBoundingClientRect();
    const relativeX = clientX - containerRect.left;
    const percentage = Math.max(
      0,
      Math.min(100, (relativeX / containerRect.width) * 100)
    );

    this.updateModalSliderPosition(
      handle,
      line,
      afterImage,
      percentage,
      slideIndex
    );
  }

  updateModalSliderPosition(
    handle,
    line,
    afterImage,
    percentage,
    slideIndex = null
  ) {
    handle.dataset.currentPosition = percentage.toString();
    handle.style.left = `${percentage}%`;
    line.style.left = `${percentage}%`;
    afterImage.style.clipPath = `polygon(${percentage}% 0%, 100% 0%, 100% 100%, ${percentage}% 100%)`;
    if (slideIndex !== null && this.modalSlidersState[slideIndex]) {
      this.modalSlidersState[slideIndex].currentPosition = percentage;
    }
  }

  preventSwiperOnBeforeAfter(modal) {
    // Look for both class variants
    const imageContainers = modal.querySelectorAll(
      ".atc-bundle-sor__image-container, .results-showcase__image-container"
    );

    imageContainers.forEach((container) => {
      // Disable swiper when touching the before/after container
      const disableSwiper = (e) => {
        if (this.modalSwiper) {
          this.modalSwiper.allowTouchMove = false;
          this.isSwiperInteracting = true;
        }
        // Don't stop propagation - let the before/after handlers work
      };

      const enableSwiper = (e) => {
        if (this.modalSwiper) {
          setTimeout(() => {
            if (this.modalSwiper) {
              this.modalSwiper.allowTouchMove = true;
            }
            this.isSwiperInteracting = false;
          }, 100);
        }
      };

      // Disable swiper on touch/mouse start
      container.addEventListener("touchstart", disableSwiper, {
        passive: true,
      });
      container.addEventListener("mousedown", disableSwiper, { passive: true });

      // Re-enable swiper after touch/mouse end
      container.addEventListener("touchend", enableSwiper, { passive: true });
      container.addEventListener("mouseup", enableSwiper, { passive: true });

      // Re-enable if touch is cancelled
      container.addEventListener("touchcancel", enableSwiper, {
        passive: true,
      });
    });
  }

  trackModalOpen(modalType, buttonText) {
    if (typeof gtag !== "undefined") {
      gtag("event", "modal_open", {
        modal_type: modalType,
        trigger_button: buttonText,
        section: "atc-bundle-sor",
      });
    }
  }

  initStickyBar() {
    this.stickyBar = document.getElementById("atc-sticky-bar");
    this.mainCTA = this.container.querySelector(".atc-bundle-sor__cta-button");

    if (!this.stickyBar || !this.mainCTA) {
      return;
    }

    this.stickyDesktopVariants = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-variant"
    );
    this.stickyMobileVariants = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-mobile-variant"
    );
    this.stickyDesktopFrequencies = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-frequency"
    );
    this.stickyMobileFrequencies = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-mobile-frequency-option-btn"
    );

    this.setupStickyBarVisibility();
    this.setupStickyBarInteractions();

    this.updateAllVariantsPricing();

    this.updateStickyDiscountBadges();
  }

  setupStickyBarVisibility() {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };

    this.stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;

        if (entry.isIntersecting) {
          this.hideStickyBar();
        } else {
          if (scrollTop > 300) {
            this.showStickyBar();
          } else {
            this.hideStickyBar();
          }
        }
      });
    }, observerOptions);

    this.stickyObserver.observe(this.mainCTA);
  }

  showStickyBar() {
    if (this.stickyBar) {
      this.stickyBar.style.display = "block";
      requestAnimationFrame(() => {
        this.stickyBar.style.opacity = "1";
        this.stickyBar.style.transform = "translateY(0)";
      });
    }
  }

  hideStickyBar() {
    if (this.stickyBar) {
      this.stickyBar.style.opacity = "0";
      this.stickyBar.style.transform = "translateY(100%)";
      setTimeout(() => {
        this.stickyBar.style.display = "none";
      }, 300);
    }
  }

  setupStickyBarInteractions() {
    const mobileToggles = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-mobile-toggle"
    );
    const mobileCollapsed = this.stickyBar.querySelector(
      "#sticky-mobile-collapsed"
    );
    const mobileExpanded = this.stickyBar.querySelector(
      "#sticky-mobile-expanded"
    );
    const mobileOverlay = document.getElementById("mobile-sticky-overlay");

    const toggleMobileState = (e) => {
      e.preventDefault();

      const isExpanded =
        mobileExpanded.style.display !== "none" &&
        mobileExpanded.style.display !== "";

      const collapsedToggleIcon = mobileCollapsed.querySelector(
        ".atc-bundle-sor__sticky-toggle-icon"
      );
      const expandedToggleIcon = mobileExpanded.querySelector(
        ".atc-bundle-sor__sticky-toggle-icon"
      );

      if (isExpanded) {
        mobileExpanded.style.display = "none";
        mobileCollapsed.style.display = "flex";
        if (mobileOverlay) {
          mobileOverlay.classList.remove(
            "atc-bundle-sor__mobile-overlay--active"
          );
        }
        if (collapsedToggleIcon) {
          collapsedToggleIcon.classList.remove(
            "atc-bundle-sor__sticky-toggle-icon--up"
          );
        }
      } else {
        mobileCollapsed.style.display = "none";
        mobileExpanded.style.display = "flex";
        if (mobileOverlay) {
          mobileOverlay.classList.add("atc-bundle-sor__mobile-overlay--active");
        }
        if (expandedToggleIcon) {
          expandedToggleIcon.classList.add(
            "atc-bundle-sor__sticky-toggle-icon--up"
          );
        }
      }
    };

    if (mobileCollapsed && mobileExpanded) {
      mobileToggles.forEach((toggle, index) => {
        toggle.addEventListener("click", toggleMobileState);
      });
    } else {
    }

    if (mobileOverlay) {
      mobileOverlay.addEventListener("click", () => {
        if (mobileExpanded && mobileCollapsed) {
          mobileExpanded.style.display = "none";
          mobileCollapsed.style.display = "flex";
          mobileOverlay.classList.remove(
            "atc-bundle-sor__mobile-overlay--active"
          );

          const collapsedToggleIcon = mobileCollapsed.querySelector(
            ".atc-bundle-sor__sticky-toggle-icon"
          );
          if (collapsedToggleIcon) {
            collapsedToggleIcon.classList.remove(
              "atc-bundle-sor__sticky-toggle-icon--up"
            );
          }
        }
      });
    }

    const desktopVariants = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-variant"
    );
    desktopVariants.forEach((variant) => {
      variant.addEventListener("click", () => {
        desktopVariants.forEach((v) =>
          v.classList.remove("atc-bundle-sor__sticky-variant--selected")
        );
        variant.classList.add("atc-bundle-sor__sticky-variant--selected");

        const variantId = variant.dataset.variantId;
        this.updateStickyPricing(variantId);

        this.updateMobileFrequencyPricing();

        this.updateStickyDiscountBadges();

        this.syncMainWithStickyVariant(variantId);
      });
    });

    const mobileVariants = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-mobile-variant"
    );
    mobileVariants.forEach((variant) => {
      variant.addEventListener("click", () => {
        mobileVariants.forEach((v) =>
          v.classList.remove("atc-bundle-sor__sticky-mobile-variant--selected")
        );
        variant.classList.add(
          "atc-bundle-sor__sticky-mobile-variant--selected"
        );

        const variantId = variant.dataset.variantId;
        this.updateStickyPricing(variantId);

        this.updateMobileFrequencyPricing();

        this.updateStickyDiscountBadges();

        this.syncMainWithStickyVariant(variantId);
      });
    });

    const desktopFrequencies = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-frequency"
    );
    desktopFrequencies.forEach((freq) => {
      freq.addEventListener("click", () => {
        if (
          this.subscriptionDisabled &&
          freq.dataset.frequency === "subscription"
        ) {
          return;
        }

        if (this._syncInProgress) {
          return;
        }

        desktopFrequencies.forEach((f) =>
          f.classList.remove("atc-bundle-sor__sticky-frequency--selected")
        );
        freq.classList.add("atc-bundle-sor__sticky-frequency--selected");

        const frequency = freq.dataset.frequency;
        if (frequency === "onetime") {
          this.currentFrequency = "onetime";
          this.currentSellingPlanId = null;
        } else if (frequency === "subscription") {
          if (this.currentSellingPlanId) {
            this.currentFrequency = `selling_plan_${this.currentSellingPlanId}`;
          } else {
            const mainSubscriptionInput = this.container.querySelector(
              'input[name="frequency"][value^="selling_plan_"]:checked'
            );

            if (mainSubscriptionInput && mainSubscriptionInput.value) {
              this.currentFrequency = mainSubscriptionInput.value;
              this.currentSellingPlanId = mainSubscriptionInput.value.replace(
                "selling_plan_",
                ""
              );
            } else {
              const mainSubscriptionChecked = this.container.querySelector(
                "#frequency-subscription"
              );
              if (
                mainSubscriptionChecked &&
                mainSubscriptionChecked.dataset.sellingPlanId
              ) {
                this.currentSellingPlanId =
                  mainSubscriptionChecked.dataset.sellingPlanId;
                this.currentFrequency = `selling_plan_${this.currentSellingPlanId}`;
              } else {
              }
            }
          }
        }

        this.updateAllVariantsPricing();

        this.syncMainWithStickyFrequency(frequency);
      });
    });

    const mobileFrequencies = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-mobile-frequency-option-btn"
    );
    mobileFrequencies.forEach((freq) => {
      freq.addEventListener("click", () => {
        if (
          this.subscriptionDisabled &&
          freq.dataset.frequency === "subscription"
        ) {
          return;
        }

        if (this._syncInProgress) {
          return;
        }

        mobileFrequencies.forEach((f) =>
          f.classList.remove(
            "atc-bundle-sor__sticky-mobile-frequency-option-btn--selected"
          )
        );
        freq.classList.add(
          "atc-bundle-sor__sticky-mobile-frequency-option-btn--selected"
        );

        const frequency = freq.dataset.frequency;
        if (frequency === "onetime") {
          this.currentFrequency = "onetime";
          this.currentSellingPlanId = null;
        } else if (frequency === "subscription" && freq.dataset.sellingPlanId) {
          this.currentSellingPlanId = freq.dataset.sellingPlanId;
          this.currentFrequency = `selling_plan_${freq.dataset.sellingPlanId}`;
        }

        this.updateAllVariantsPricing();

        this.syncMainWithStickyFrequency(this.currentFrequency);

        this.syncStickyFrequencyWithMain(this.currentFrequency);
      });
    });

    const mobileFrequencyRadios = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-mobile-frequency-input"
    );
    const mobileFrequencyContainers = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-mobile-frequency-onetime, .atc-bundle-sor__sticky-mobile-frequency-subscription"
    );

    mobileFrequencyRadios.forEach((radio) => {
      radio.addEventListener("change", (e) => {
        if (this.subscriptionDisabled && e.target.value === "subscription") {
          e.preventDefault();
          const oneTimeRadio = this.stickyBar.querySelector(
            '.atc-bundle-sor__sticky-mobile-frequency-input[value="onetime"]'
          );
          if (oneTimeRadio) {
            oneTimeRadio.checked = true;
          }
          return;
        }

        if (this._syncInProgress) {
          return;
        }

        const frequency = e.target.value;
        if (frequency === "onetime") {
          this.currentFrequency = "onetime";
          this.currentSellingPlanId = null;
        } else if (frequency === "subscription") {
          if (this.currentSellingPlanId) {
            this.currentFrequency = `selling_plan_${this.currentSellingPlanId}`;
          } else {
            const mainSubscriptionInput = this.container.querySelector(
              'input[name="frequency"][value^="selling_plan_"]:checked'
            );

            if (mainSubscriptionInput && mainSubscriptionInput.value) {
              this.currentFrequency = mainSubscriptionInput.value;
              this.currentSellingPlanId = mainSubscriptionInput.value.replace(
                "selling_plan_",
                ""
              );
            } else {
              const mainSubscriptionChecked = this.container.querySelector(
                "#frequency-subscription"
              );
              if (
                mainSubscriptionChecked &&
                mainSubscriptionChecked.dataset.sellingPlanId
              ) {
                this.currentSellingPlanId =
                  mainSubscriptionChecked.dataset.sellingPlanId;
                this.currentFrequency = `selling_plan_${this.currentSellingPlanId}`;
              } else {
              }
            }
          }
        }

        this.updateAllVariantsPricing();

        this.updateMobileFrequencyPricing();

        this.syncMainWithStickyFrequency(frequency);

        this.syncStickyFrequencyWithMain(frequency);
      });
    });

    mobileFrequencyContainers.forEach((container) => {
      container.addEventListener("click", (e) => {
        if (e.target.tagName === "LABEL" || e.target.closest("label")) {
          return;
        }

        const frequency = container.dataset.frequency;
        const radio = container.querySelector(
          ".atc-bundle-sor__sticky-mobile-frequency-input"
        );

        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    });
  }

  updateStickyPricing(variantId) {
    const selectedVariantOption = this.container.querySelector(
      `[data-variant-id="${variantId}"]`
    );
    if (!selectedVariantOption) {
      return;
    }

    const variantPrice = selectedVariantOption.dataset.variantPrice;
    if (!variantPrice) {
      return;
    }

    this.currentVariantId = variantId;
    this.currentVariantPrice = parseFloat(variantPrice);

    this.updateSellingPlansForVariant(variantId);

    this.updatePricing();

    this.updateSubscriptionDisplay();

    this.updateMobileFrequencyPricing();
  }

  updateAllVariantsPricing() {
    if (!window.variantData) {
      return;
    }

    if (!this.stickyBar) {
      return;
    }

    const isSubscription = this.isSubscriptionSelected();

    const desktopVariants =
      this.stickyDesktopVariants ||
      this.stickyBar.querySelectorAll(".atc-bundle-sor__sticky-variant");
    desktopVariants.forEach((variantElement, index) => {
      const variantId = variantElement.dataset.variantId;
      if (window.variantData[variantId]) {
        this.updateVariantPricing(variantElement, variantId, isSubscription);
      }
    });

    const mobileVariants =
      this.stickyMobileVariants ||
      this.stickyBar.querySelectorAll(".atc-bundle-sor__sticky-mobile-variant");
    mobileVariants.forEach((variantElement, index) => {
      const variantId = variantElement.dataset.variantId;
      if (window.variantData[variantId]) {
        this.updateMobileVariantPricing(
          variantElement,
          variantId,
          isSubscription
        );
      }
    });

    const currentVariantId = this.getCurrentVariantId();
    if (currentVariantId) {
      this.updateStickyPricing(currentVariantId);
    }

    this.updateStickyDiscountBadges();
  }

  updateVariantPricing(variantElement, variantId, isSubscription) {
    const variant = window.variantData[variantId];
    let formattedPrice, formattedOldPrice;

    if (isSubscription) {
      if (window.sellingPlansData && this.currentSellingPlanId) {
        const sellingPlanKey = `${variantId}_${this.currentSellingPlanId}`;
        const planData = window.sellingPlansData[sellingPlanKey];

        if (planData) {
          formattedPrice =
            (planData.allocation_price / 100).toFixed(2).replace(".", ",") +
            "€";
          if (
            variant.compare_at_price &&
            variant.compare_at_price > variant.price
          ) {
            formattedOldPrice =
              (variant.compare_at_price / 100).toFixed(2).replace(".", ",") +
              "€";
          } else {
            formattedOldPrice =
              (variant.price / 100).toFixed(2).replace(".", ",") + "€";
          }
        } else {
          const fallbackPlanData = this.findSellingPlanForVariant(
            variantId,
            this.currentSellingPlanId
          );
          if (fallbackPlanData) {
            const originalPrice = variant.price;
            const discountMultiplier =
              fallbackPlanData.discount_type === "percentage"
                ? (100 - fallbackPlanData.discount_value) / 100
                : 1;
            const discountedPrice = Math.round(
              originalPrice * discountMultiplier
            );

            formattedPrice =
              (discountedPrice / 100).toFixed(2).replace(".", ",") + "€";
            if (
              variant.compare_at_price &&
              variant.compare_at_price > variant.price
            ) {
              formattedOldPrice =
                (variant.compare_at_price / 100).toFixed(2).replace(".", ",") +
                "€";
            } else {
              formattedOldPrice =
                (variant.price / 100).toFixed(2).replace(".", ",") + "€";
            }
          } else {
            const discountedPrice = Math.round(variant.price * 0.75);
            formattedPrice =
              (discountedPrice / 100).toFixed(2).replace(".", ",") + "€";
            if (
              variant.compare_at_price &&
              variant.compare_at_price > variant.price
            ) {
              formattedOldPrice =
                (variant.compare_at_price / 100).toFixed(2).replace(".", ",") +
                "€";
            } else {
              formattedOldPrice =
                (variant.price / 100).toFixed(2).replace(".", ",") + "€";
            }
          }
        }
      } else {
        const discountedPrice = Math.round(variant.price * 0.75);
        formattedPrice =
          (discountedPrice / 100).toFixed(2).replace(".", ",") + "€";
        formattedOldPrice =
          (variant.price / 100).toFixed(2).replace(".", ",") + "€";
      }
    } else {
      formattedPrice = (variant.price / 100).toFixed(2).replace(".", ",") + "€";

      if (
        variant.compare_at_price &&
        variant.compare_at_price > variant.price
      ) {
        formattedOldPrice =
          (variant.compare_at_price / 100).toFixed(2).replace(".", ",") + "€";
      } else {
        formattedOldPrice = "";
      }
    }

    const priceElement = variantElement.querySelector(
      ".atc-bundle-sor__sticky-price"
    );
    const oldPriceElement = variantElement.querySelector(
      ".atc-bundle-sor__sticky-old-price"
    );

    if (priceElement) {
      priceElement.textContent = formattedPrice;
    } else {
    }

    if (oldPriceElement) {
      oldPriceElement.textContent = formattedOldPrice;
    } else {
    }
  }

  updateMobileVariantPricing(variantElement, variantId, isSubscription) {
    const variant = window.variantData[variantId];
    let formattedPrice, formattedOldPrice;

    if (isSubscription) {
      if (window.sellingPlansData && this.currentSellingPlanId) {
        const sellingPlanKey = `${variantId}_${this.currentSellingPlanId}`;
        const planData = window.sellingPlansData[sellingPlanKey];

        if (planData) {
          formattedPrice =
            (planData.allocation_price / 100).toFixed(2).replace(".", ",") +
            "€";
          if (
            variant.compare_at_price &&
            variant.compare_at_price > variant.price
          ) {
            formattedOldPrice =
              (variant.compare_at_price / 100).toFixed(2).replace(".", ",") +
              "€";
          } else {
            formattedOldPrice =
              (variant.price / 100).toFixed(2).replace(".", ",") + "€";
          }
        } else {
          const fallbackPlanData = this.findSellingPlanForVariant(
            variantId,
            this.currentSellingPlanId
          );
          if (fallbackPlanData) {
            const originalPrice = variant.price;
            const discountMultiplier =
              fallbackPlanData.discount_type === "percentage"
                ? (100 - fallbackPlanData.discount_value) / 100
                : 1;
            const discountedPrice = Math.round(
              originalPrice * discountMultiplier
            );

            formattedPrice =
              (discountedPrice / 100).toFixed(2).replace(".", ",") + "€";
            if (
              variant.compare_at_price &&
              variant.compare_at_price > variant.price
            ) {
              formattedOldPrice =
                (variant.compare_at_price / 100).toFixed(2).replace(".", ",") +
                "€";
            } else {
              formattedOldPrice =
                (variant.price / 100).toFixed(2).replace(".", ",") + "€";
            }
          } else {
            const discountedPrice = Math.round(variant.price * 0.75);
            formattedPrice =
              (discountedPrice / 100).toFixed(2).replace(".", ",") + "€";
            formattedOldPrice =
              (variant.price / 100).toFixed(2).replace(".", ",") + "€";
          }
        }
      } else {
        const discountedPrice = Math.round(variant.price * 0.75);
        formattedPrice =
          (discountedPrice / 100).toFixed(2).replace(".", ",") + "€";
        formattedOldPrice =
          (variant.price / 100).toFixed(2).replace(".", ",") + "€";
      }
    } else {
      formattedPrice = (variant.price / 100).toFixed(2).replace(".", ",") + "€";

      if (
        variant.compare_at_price &&
        variant.compare_at_price > variant.price
      ) {
        formattedOldPrice =
          (variant.compare_at_price / 100).toFixed(2).replace(".", ",") + "€";
      } else {
        formattedOldPrice = "";
      }
    }

    const priceElement = variantElement.querySelector(
      ".atc-bundle-sor__sticky-mobile-price"
    );
    const oldPriceElement = variantElement.querySelector(
      ".atc-bundle-sor__sticky-mobile-old-price"
    );

    if (priceElement) {
      priceElement.textContent = formattedPrice;
    } else {
    }

    if (oldPriceElement) {
      oldPriceElement.textContent = formattedOldPrice;
    } else {
    }
  }

  syncVariantWithMainForm(variantId) {
    const mainVariantInputs =
      this.container.querySelectorAll('input[name="id"]');
    mainVariantInputs.forEach((input) => {
      if (input.value === variantId) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  syncStickyBarWithMainForm() {
    const mainForm = this.container.querySelector(".atc-bundle-sor__form");
    if (mainForm) {
      mainForm.addEventListener("change", (e) => {
        if (e.target.name === "id") {
          this.updateStickyBarSelection(e.target.value);
        }

        if (
          e.target.name === "selling_plan" ||
          e.target.name === "frequency" ||
          e.target.classList.contains("frequency-option")
        ) {
          this.updateAllVariantsPricing();
          this.updateStickyFrequencySelection();
        }
      });
    }
  }

  updateStickyBarSelection(variantId) {
    const stickyVariants = this.stickyBar.querySelectorAll("[data-variant-id]");
    stickyVariants.forEach((variant) => {
      if (variant.dataset.variantId === variantId) {
        variant.classList.add(
          "atc-bundle-sor__sticky-variant--selected",
          "atc-bundle-sor__sticky-mobile-variant--selected"
        );
      } else {
        variant.classList.remove(
          "atc-bundle-sor__sticky-variant--selected",
          "atc-bundle-sor__sticky-mobile-variant--selected"
        );
      }
    });

    this.updateStickyPricing(variantId);
  }

  async handleStickyAddToCart(e) {
    e.preventDefault();

    if (!this.currentVariantId) {
      return;
    }

    const button = e.currentTarget;
    const quantity = this.getQuantity();

    const originalText = button.innerHTML;
    button.innerHTML = "Ajout en cours...";
    button.disabled = true;

    try {
      let sectionsToBundle = ["variant-added"];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      const formData = new FormData();
      formData.append("id", this.currentVariantId);
      formData.append("quantity", quantity);
      if (this.currentSellingPlanId) {
        formData.append("selling_plan", this.currentSellingPlanId);
      }
      formData.append("sections", sectionsToBundle.join(","));
      formData.append(
        "sections_url",
        `${window.Shopify.routes.root}variants/${this.currentVariantId}`
      );

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      });

      if (response.ok) {
        const result = await response.json();

        const cartResponse = await fetch(
          `${window.Shopify.routes.root}cart.js`
        );
        const cartData = await cartResponse.json();
        cartData["sections"] = result["sections"];

        document.documentElement.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              cart: cartData,
            },
          })
        );

        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              cart: cartData,
            },
          })
        );

        button.innerHTML = "✓ Ajouté !";
        setTimeout(() => {
          button.innerHTML = originalText;
          button.disabled = false;
        }, 2000);
      } else {
        throw new Error("Failed to add to cart");
      }
    } catch (error) {
      button.innerHTML = "Erreur";
      setTimeout(() => {
        button.innerHTML = originalText;
        button.disabled = false;
      }, 2000);
    }
  }

  syncStickyFrequencyWithMain(frequency) {
    if (!this.stickyBar) return;

    const desktopFrequencies = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-frequency"
    );
    desktopFrequencies.forEach((freq) => {
      freq.classList.remove("atc-bundle-sor__sticky-frequency--selected");
      if (frequency === "onetime" && freq.dataset.frequency === "onetime") {
        freq.classList.add("atc-bundle-sor__sticky-frequency--selected");
      } else if (
        frequency.startsWith("selling_plan_") &&
        freq.dataset.frequency === "subscription"
      ) {
        freq.classList.add("atc-bundle-sor__sticky-frequency--selected");
      }
    });

    const mobileFrequencyInputs = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-mobile-frequency-input"
    );
    mobileFrequencyInputs.forEach((input) => {
      if (frequency === "onetime" && input.value === "onetime") {
        input.checked = true;
      } else if (
        frequency.startsWith("selling_plan_") &&
        input.value === "subscription"
      ) {
        input.checked = true;
      } else {
        input.checked = false;
      }
    });
  }

  syncStickyPeriodWithMain(sellingPlanId) {
    if (!this.stickyBar) return;

    const desktopPeriodButtons = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-period-option"
    );
    desktopPeriodButtons.forEach((btn) => {
      btn.classList.remove("atc-bundle-sor__sticky-period-option--active");
      if (btn.dataset.sellingPlanId === sellingPlanId) {
        btn.classList.add("atc-bundle-sor__sticky-period-option--active");
      }
    });

    const mobilePeriodButtons = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-mobile-frequency-option-btn"
    );
    mobilePeriodButtons.forEach((btn) => {
      btn.classList.remove(
        "atc-bundle-sor__sticky-mobile-frequency-option-btn--selected"
      );
      if (btn.dataset.sellingPlanId === sellingPlanId) {
        btn.classList.add(
          "atc-bundle-sor__sticky-mobile-frequency-option-btn--selected"
        );
      }
    });
  }

  syncStickyVariantWithMain(variantId) {
    if (!this.stickyBar) return;

    const desktopVariants = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-variant"
    );
    desktopVariants.forEach((variant) => {
      variant.classList.remove("atc-bundle-sor__sticky-variant--selected");
      if (variant.dataset.variantId === variantId) {
        variant.classList.add("atc-bundle-sor__sticky-variant--selected");
      }
    });

    const mobileVariants = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-mobile-variant"
    );
    mobileVariants.forEach((variant) => {
      variant.classList.remove(
        "atc-bundle-sor__sticky-mobile-variant--selected"
      );
      if (variant.dataset.variantId === variantId) {
        variant.classList.add(
          "atc-bundle-sor__sticky-mobile-variant--selected"
        );
      }
    });
  }

  syncMainWithStickyFrequency(frequency) {
    if (this._syncInProgress) {
      return;
    }
    this._syncInProgress = true;

    try {
      const mainFrequencyInputs = this.container.querySelectorAll(
        ".atc-bundle-sor__frequency-input"
      );

      mainFrequencyInputs.forEach((input) => {
        const oldChecked = input.checked;

        if (frequency === "onetime" && input.value === "onetime") {
          input.checked = true;
          this.currentFrequency = "onetime";
          this.currentSellingPlanId = null;
        } else if (
          frequency.startsWith("selling_plan_") &&
          input.value === frequency
        ) {
          input.checked = true;
        } else {
          input.checked = false;
          if (oldChecked) {
          }
        }
      });

      this.updateFrequencyCards();
      this.updatePricing();
      this.updateSubscriptionDisplay();

      if (frequency.startsWith("selling_plan_")) {
        const sellingPlanId = frequency.replace("selling_plan_", "");

        const periodButtons = this.container.querySelectorAll(
          ".atc-bundle-sor__period-option"
        );
        periodButtons.forEach((btn) => {
          const isActive = btn.dataset.sellingPlanId === sellingPlanId;
          btn.classList.toggle(
            "atc-bundle-sor__period-option--active",
            isActive
          );
          if (isActive) {
          }
        });
      }
    } finally {
      this._syncInProgress = false;
    }
  }

  updateStickyDiscountBadges() {
    if (!this.isSubscriptionSelected()) {
      const stickyDiscountBadge = this.stickyBar.querySelector(
        ".atc-bundle-sor__sticky-discount-badge"
      );
      const stickyMobileDiscountBadge = this.stickyBar.querySelector(
        ".atc-bundle-sor__sticky-mobile-discount-badge"
      );

      if (stickyDiscountBadge) stickyDiscountBadge.style.display = "none";
      if (stickyMobileDiscountBadge)
        stickyMobileDiscountBadge.style.display = "none";
      return;
    }

    let currentVariantId = this.currentVariantId;
    let currentSellingPlanId = this.currentSellingPlanId;

    if (!currentVariantId) {
      currentVariantId = this.getCurrentVariantId();
    }

    if (
      !currentSellingPlanId &&
      this.currentFrequency &&
      this.currentFrequency.startsWith("selling_plan_")
    ) {
      currentSellingPlanId = this.currentFrequency.replace("selling_plan_", "");
    }

    if (!currentVariantId || !currentSellingPlanId) {
      return;
    }

    const planData = this.findSellingPlanForVariant(
      currentVariantId,
      currentSellingPlanId
    );
    if (!planData) {
      return;
    }

    let discountText = "";
    if (planData.discount_type === "percentage") {
      discountText = `-${planData.discount_value}%`;
    } else if (planData.discount_type === "fixed_amount") {
      discountText = `-${(planData.discount_value / 100).toFixed(2)}€`;
    }

    const stickyDiscountBadge = this.stickyBar.querySelector(
      ".atc-bundle-sor__sticky-discount-badge span"
    );
    if (stickyDiscountBadge) {
      stickyDiscountBadge.textContent = discountText;
      stickyDiscountBadge.parentElement.style.display = "block";
    }

    const stickyMobileDiscountBadge = this.stickyBar.querySelector(
      ".atc-bundle-sor__sticky-mobile-discount-badge span"
    );
    if (stickyMobileDiscountBadge) {
      stickyMobileDiscountBadge.textContent = discountText;
      stickyMobileDiscountBadge.parentElement.style.display = "block";
    }
  }

  syncMainWithStickyVariant(variantId) {
    if (this._syncInProgress) return;
    this._syncInProgress = true;

    try {
      const mainVariantOption = this.container.querySelector(
        `[data-variant-id="${variantId}"]`
      );
      if (mainVariantOption) {
        this.currentVariantId = variantId;
        this.currentVariantPrice = parseFloat(
          mainVariantOption.dataset.variantPrice
        );

        this.updateVariantSelection(mainVariantOption);
        this.updateSellingPlansForVariant(variantId);
        this.updatePricing();
        this.updateSubscriptionDisplay();
        this.updateVariantSavingsBadges();
      }
    } finally {
      this._syncInProgress = false;
    }
  }

  isSubscriptionSelected() {
    if (this.currentFrequency) {
      const isSubscription = this.currentFrequency.startsWith("selling_plan_");
      return isSubscription;
    }

    const stickySubscriptionSelected = this.stickyBar?.querySelector(
      '.atc-bundle-sor__sticky-frequency--selected[data-frequency="subscription"]'
    );

    const mobileSubscriptionRadio = this.stickyBar?.querySelector(
      '.atc-bundle-sor__sticky-mobile-frequency-input[value="subscription"]:checked'
    );

    const mobileFrequencyBtn = this.stickyBar?.querySelector(
      '.atc-bundle-sor__sticky-mobile-frequency-option-btn--selected[data-frequency="subscription"]'
    );

    const mainSubscriptionInput = this.container.querySelector(
      'input[name="selling_plan"]:checked'
    );

    const result = !!(
      stickySubscriptionSelected ||
      mobileSubscriptionRadio ||
      mobileFrequencyBtn ||
      mainSubscriptionInput
    );

    return result;
  }

  getCurrentVariantId() {
    const stickySelected = this.stickyBar.querySelector(
      ".atc-bundle-sor__sticky-variant--selected, .atc-bundle-sor__sticky-mobile-variant--selected"
    );
    if (stickySelected) {
      return stickySelected.dataset.variantId;
    }

    const mainSelected = this.container.querySelector(
      'input[name="id"]:checked'
    );
    return mainSelected ? mainSelected.value : null;
  }

  syncFrequencyWithMainForm(frequency) {
    if (frequency === "subscription") {
      const mainSubscriptionInput = this.container.querySelector(
        'input[name="selling_plan"][value]:first-of-type'
      );
      if (mainSubscriptionInput) {
        mainSubscriptionInput.checked = true;
        mainSubscriptionInput.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      }
    } else {
      const mainOneTimeInput = this.container.querySelector(
        'input[name="selling_plan"][value=""]'
      );
      if (mainOneTimeInput) {
        mainOneTimeInput.checked = true;
        mainOneTimeInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  updateStickyFrequencySelection() {
    const mainSubscriptionInput = this.container.querySelector(
      'input[name="selling_plan"]:checked'
    );
    const isSubscription =
      mainSubscriptionInput && mainSubscriptionInput.value !== "";

    const desktopFrequencies = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-frequency"
    );
    desktopFrequencies.forEach((freq) => {
      const isSubscriptionButton = freq.dataset.frequency === "subscription";
      freq.classList.toggle(
        "atc-bundle-sor__sticky-frequency--selected",
        isSubscriptionButton === isSubscription
      );
    });

    const mobileFrequencies = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-mobile-frequency-option-btn"
    );
    mobileFrequencies.forEach((freq) => {
      const isSubscriptionButton = freq.dataset.frequency === "subscription";
      freq.classList.toggle(
        "atc-bundle-sor__sticky-mobile-frequency-option-btn--selected",
        isSubscriptionButton === isSubscription
      );
    });
  }

  updateMobileFrequencyPricing() {
    const onetimePriceElement = this.stickyBar.querySelector(
      ".atc-bundle-sor__sticky-mobile-frequency-price"
    );
    if (onetimePriceElement && this.currentVariantPrice) {
      const price = this.currentVariantPrice / 100;
      const formattedPrice = `${price.toFixed(2).replace(".", ",")}€`;
      onetimePriceElement.textContent = formattedPrice;
    }

    const subscriptionPriceElement = this.stickyBar.querySelector(
      ".atc-bundle-sor__sticky-mobile-sub-price"
    );
    if (
      subscriptionPriceElement &&
      this.currentSellingPlanId &&
      this.currentVariantId
    ) {
      const planData = this.findSellingPlanForVariant(
        this.currentVariantId,
        this.currentSellingPlanId
      );
      if (planData) {
        const price = planData.allocation_price / 100;
        const formattedPrice = `${price.toFixed(2).replace(".", ",")}€`;
        subscriptionPriceElement.textContent = formattedPrice;
      }
    }

    const subscriptionOldPriceElement = this.stickyBar.querySelector(
      ".atc-bundle-sor__sticky-mobile-sub-old-price"
    );
    if (subscriptionOldPriceElement && this.currentVariantPrice) {
      const originalPrice = this.currentVariantPrice / 100;
      const formattedPrice = `${originalPrice.toFixed(2).replace(".", ",")}€`;
      subscriptionOldPriceElement.textContent = formattedPrice;
    }
  }

  syncMobileFrequencyWithDesktop(mobileFrequency) {
    const desktopFrequencies = this.stickyBar.querySelectorAll(
      ".atc-bundle-sor__sticky-frequency"
    );
    desktopFrequencies.forEach((freq) => {
      if (freq.dataset.frequency === mobileFrequency) {
        freq.classList.add("atc-bundle-sor__sticky-frequency--selected");
      } else {
        freq.classList.remove("atc-bundle-sor__sticky-frequency--selected");
      }
    });

    const mainFrequencyInputs = this.container.querySelectorAll(
      'input[name="selling_plan"], input[name="id"]'
    );
    if (mobileFrequency === "subscription") {
      const subscriptionInput = this.container.querySelector(
        'input[name="selling_plan"]'
      );
      if (subscriptionInput) {
        subscriptionInput.checked = true;
      }
    } else {
      const onetimeInput = this.container.querySelector('input[name="id"]');
      if (onetimeInput) {
        onetimeInput.checked = true;
      }
    }
  }
}

function initializeATCBundleSections() {
  const sections = document.querySelectorAll(".atc-bundle-sor");
  console.log(sections);
  sections.forEach((section) => {
    if (!section.atcBundleInstance) {
      section.atcBundleInstance = new ATCBundleSOR(section);
    }
  });
}

